var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/errors/IdentityKitError.ts
var IdentityKitErrorCode = /* @__PURE__ */ ((IdentityKitErrorCode2) => {
  IdentityKitErrorCode2["INVALID_CONFIGURATION"] = "INVALID_CONFIGURATION";
  IdentityKitErrorCode2["ENVIRONMENT_NOT_SUPPORTED"] = "ENVIRONMENT_NOT_SUPPORTED";
  IdentityKitErrorCode2["INITIALIZATION_FAILED"] = "INITIALIZATION_FAILED";
  IdentityKitErrorCode2["DID_NOT_FOUND"] = "DID_NOT_FOUND";
  IdentityKitErrorCode2["DID_INVALID_FORMAT"] = "DID_INVALID_FORMAT";
  IdentityKitErrorCode2["DID_METHOD_NOT_SUPPORTED"] = "DID_METHOD_NOT_SUPPORTED";
  IdentityKitErrorCode2["DID_CREATION_FAILED"] = "DID_CREATION_FAILED";
  IdentityKitErrorCode2["DID_RESOLUTION_FAILED"] = "DID_RESOLUTION_FAILED";
  IdentityKitErrorCode2["DID_NOT_SET"] = "DID_NOT_SET";
  IdentityKitErrorCode2["DID_SERVICE_NOT_FOUND"] = "DID_SERVICE_NOT_FOUND";
  IdentityKitErrorCode2["DID_VERIFICATION_METHOD_NOT_FOUND"] = "DID_VERIFICATION_METHOD_NOT_FOUND";
  IdentityKitErrorCode2["VDR_NOT_AVAILABLE"] = "VDR_NOT_AVAILABLE";
  IdentityKitErrorCode2["VDR_OPERATION_FAILED"] = "VDR_OPERATION_FAILED";
  IdentityKitErrorCode2["VDR_NETWORK_ERROR"] = "VDR_NETWORK_ERROR";
  IdentityKitErrorCode2["VDR_INVALID_RESPONSE"] = "VDR_INVALID_RESPONSE";
  IdentityKitErrorCode2["KEY_NOT_FOUND"] = "KEY_NOT_FOUND";
  IdentityKitErrorCode2["KEY_INVALID_FORMAT"] = "KEY_INVALID_FORMAT";
  IdentityKitErrorCode2["KEY_GENERATION_FAILED"] = "KEY_GENERATION_FAILED";
  IdentityKitErrorCode2["KEY_IMPORT_FAILED"] = "KEY_IMPORT_FAILED";
  IdentityKitErrorCode2["KEY_STORAGE_ERROR"] = "KEY_STORAGE_ERROR";
  IdentityKitErrorCode2["KEY_PERMISSION_DENIED"] = "KEY_PERMISSION_DENIED";
  IdentityKitErrorCode2["KEY_VALIDATION_FAILED"] = "KEY_VALIDATION_FAILED";
  IdentityKitErrorCode2["KEY_PRIVATE_KEY_NOT_AVAILABLE"] = "KEY_PRIVATE_KEY_NOT_AVAILABLE";
  IdentityKitErrorCode2["KEY_DID_MISMATCH"] = "KEY_DID_MISMATCH";
  IdentityKitErrorCode2["KEY_ID_MISMATCH"] = "KEY_ID_MISMATCH";
  IdentityKitErrorCode2["KEY_TYPE_NOT_SUPPORTED"] = "KEY_TYPE_NOT_SUPPORTED";
  IdentityKitErrorCode2["KEY_ALREADY_EXISTS"] = "KEY_ALREADY_EXISTS";
  IdentityKitErrorCode2["SIGNING_FAILED"] = "SIGNING_FAILED";
  IdentityKitErrorCode2["SIGNATURE_VERIFICATION_FAILED"] = "SIGNATURE_VERIFICATION_FAILED";
  IdentityKitErrorCode2["SIGNER_NOT_AVAILABLE"] = "SIGNER_NOT_AVAILABLE";
  IdentityKitErrorCode2["SIGNER_INVALID_DID"] = "SIGNER_INVALID_DID";
  IdentityKitErrorCode2["SIGNER_NO_KEYS"] = "SIGNER_NO_KEYS";
  IdentityKitErrorCode2["AUTH_INVALID_HEADER"] = "AUTH_INVALID_HEADER";
  IdentityKitErrorCode2["AUTH_INVALID_BASE64"] = "AUTH_INVALID_BASE64";
  IdentityKitErrorCode2["AUTH_INVALID_JSON"] = "AUTH_INVALID_JSON";
  IdentityKitErrorCode2["AUTH_MISSING_SIGNATURE"] = "AUTH_MISSING_SIGNATURE";
  IdentityKitErrorCode2["AUTH_TIMESTAMP_OUT_OF_WINDOW"] = "AUTH_TIMESTAMP_OUT_OF_WINDOW";
  IdentityKitErrorCode2["AUTH_NONCE_REPLAYED"] = "AUTH_NONCE_REPLAYED";
  IdentityKitErrorCode2["AUTH_DID_DOCUMENT_NOT_FOUND"] = "AUTH_DID_DOCUMENT_NOT_FOUND";
  IdentityKitErrorCode2["AUTH_VERIFICATION_METHOD_NOT_FOUND"] = "AUTH_VERIFICATION_METHOD_NOT_FOUND";
  IdentityKitErrorCode2["AUTH_INVALID_PUBLIC_KEY"] = "AUTH_INVALID_PUBLIC_KEY";
  IdentityKitErrorCode2["AUTH_DID_MISMATCH"] = "AUTH_DID_MISMATCH";
  IdentityKitErrorCode2["WEB_BROWSER_NOT_SUPPORTED"] = "WEB_BROWSER_NOT_SUPPORTED";
  IdentityKitErrorCode2["WEB_STORAGE_NOT_AVAILABLE"] = "WEB_STORAGE_NOT_AVAILABLE";
  IdentityKitErrorCode2["WEB_DEEPLINK_FAILED"] = "WEB_DEEPLINK_FAILED";
  IdentityKitErrorCode2["WEB_CADOP_CONNECTION_FAILED"] = "WEB_CADOP_CONNECTION_FAILED";
  IdentityKitErrorCode2["WEB_OAUTH_CALLBACK_FAILED"] = "WEB_OAUTH_CALLBACK_FAILED";
  IdentityKitErrorCode2["WEB_NOT_CONNECTED"] = "WEB_NOT_CONNECTED";
  IdentityKitErrorCode2["WEB_CALLBACK_FAILED"] = "WEB_CALLBACK_FAILED";
  IdentityKitErrorCode2["REACT_NOT_AVAILABLE"] = "REACT_NOT_AVAILABLE";
  IdentityKitErrorCode2["REACT_HOOK_MISUSE"] = "REACT_HOOK_MISUSE";
  IdentityKitErrorCode2["CRYPTO_PROVIDER_NOT_FOUND"] = "CRYPTO_PROVIDER_NOT_FOUND";
  IdentityKitErrorCode2["CRYPTO_OPERATION_FAILED"] = "CRYPTO_OPERATION_FAILED";
  IdentityKitErrorCode2["CRYPTO_KEY_DERIVATION_FAILED"] = "CRYPTO_KEY_DERIVATION_FAILED";
  IdentityKitErrorCode2["MULTIBASE_DECODE_FAILED"] = "MULTIBASE_DECODE_FAILED";
  IdentityKitErrorCode2["MULTIBASE_ENCODE_FAILED"] = "MULTIBASE_ENCODE_FAILED";
  IdentityKitErrorCode2["MULTIBASE_INVALID_FORMAT"] = "MULTIBASE_INVALID_FORMAT";
  IdentityKitErrorCode2["SCOPE_VALIDATION_FAILED"] = "SCOPE_VALIDATION_FAILED";
  IdentityKitErrorCode2["SCOPE_INVALID_FORMAT"] = "SCOPE_INVALID_FORMAT";
  IdentityKitErrorCode2["VALIDATION_FAILED"] = "VALIDATION_FAILED";
  IdentityKitErrorCode2["INVALID_INPUT_FORMAT"] = "INVALID_INPUT_FORMAT";
  IdentityKitErrorCode2["DEEPLINK_INVALID_STATE"] = "DEEPLINK_INVALID_STATE";
  IdentityKitErrorCode2["DEEPLINK_CALLBACK_FAILED"] = "DEEPLINK_CALLBACK_FAILED";
  IdentityKitErrorCode2["STORAGE_QUOTA_EXCEEDED"] = "STORAGE_QUOTA_EXCEEDED";
  IdentityKitErrorCode2["STORAGE_OPERATION_FAILED"] = "STORAGE_OPERATION_FAILED";
  IdentityKitErrorCode2["SIGNER_CONVERSION_FAILED"] = "SIGNER_CONVERSION_FAILED";
  IdentityKitErrorCode2["SIGNER_OPERATION_FAILED"] = "SIGNER_OPERATION_FAILED";
  IdentityKitErrorCode2["PERMISSION_DENIED"] = "PERMISSION_DENIED";
  IdentityKitErrorCode2["OPERATION_NOT_PERMITTED"] = "OPERATION_NOT_PERMITTED";
  IdentityKitErrorCode2["OPERATION_NOT_SUPPORTED"] = "OPERATION_NOT_SUPPORTED";
  IdentityKitErrorCode2["INVALID_PARAMETER"] = "INVALID_PARAMETER";
  IdentityKitErrorCode2["INTERNAL_ERROR"] = "INTERNAL_ERROR";
  IdentityKitErrorCode2["NETWORK_ERROR"] = "NETWORK_ERROR";
  IdentityKitErrorCode2["TIMEOUT_ERROR"] = "TIMEOUT_ERROR";
  return IdentityKitErrorCode2;
})(IdentityKitErrorCode || {});
var IdentityKitError = class extends Error {
  constructor(code, message, options) {
    super(message);
    this.name = "IdentityKitError";
    this.code = code;
    this.category = options?.category || this.inferCategory(code);
    this.details = options?.details;
    this.cause = options?.cause;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
    if (options?.cause) {
      this.stack = `${this.stack}
Caused by: ${options.cause.stack}`;
    }
  }
  /**
   * Infer error category from error code
   */
  inferCategory(code) {
    if (code.startsWith("AUTH_")) return "authentication";
    if (code.startsWith("DID_")) return "did";
    if (code.startsWith("VDR_")) return "vdr";
    if (code.startsWith("KEY_")) return "key-management";
    if (code.startsWith("WEB_")) return "web";
    if (code.startsWith("REACT_")) return "react";
    if (code.startsWith("CRYPTO_")) return "crypto";
    if (code.startsWith("MULTIBASE_")) return "multibase";
    if (code.startsWith("SCOPE_") || code.startsWith("VALIDATION_")) return "validation";
    if (code.startsWith("DEEPLINK_")) return "deeplink";
    if (code.startsWith("STORAGE_")) return "storage";
    if (code.startsWith("SIGNER_")) return "signer";
    if (code.includes("SIGNING") || code.includes("SIGNATURE")) return "signing";
    if (code.includes("NETWORK")) return "network";
    if (code.includes("PERMISSION")) return "permission";
    return "general";
  }
  /**
   * Convert to a plain object for serialization
   */
  toJSON() {
    return {
      name: this.name,
      code: this.code,
      category: this.category,
      message: this.message,
      details: this.details,
      stack: this.stack
    };
  }
  /**
   * Get a user-friendly error message with suggestions
   */
  getUserMessage() {
    const suggestions = this.getSuggestions();
    let message = this.message;
    if (suggestions.length > 0) {
      message += "\n\nSuggestions:\n" + suggestions.map((s) => `\u2022 ${s}`).join("\n");
    }
    return message;
  }
  /**
   * Get contextual suggestions based on error code
   */
  getSuggestions() {
    switch (this.code) {
      case "WEB_BROWSER_NOT_SUPPORTED" /* WEB_BROWSER_NOT_SUPPORTED */:
        return [
          "Use a modern browser that supports required Web APIs",
          "Check if you're running in a browser environment"
        ];
      case "WEB_STORAGE_NOT_AVAILABLE" /* WEB_STORAGE_NOT_AVAILABLE */:
        return [
          "Enable localStorage or IndexedDB in your browser",
          "Check if you're in private/incognito mode",
          "Consider using memory storage as fallback"
        ];
      case "DID_METHOD_NOT_SUPPORTED" /* DID_METHOD_NOT_SUPPORTED */:
        return [
          "Check if the DID method is registered with VDRRegistry",
          "Verify the DID format is correct"
        ];
      case "VDR_NETWORK_ERROR" /* VDR_NETWORK_ERROR */:
        return [
          "Check your network connection",
          "Verify the RPC URL is correct and accessible",
          "Check if the VDR service is running"
        ];
      case "KEY_STORAGE_ERROR" /* KEY_STORAGE_ERROR */:
        return [
          "Check browser storage permissions",
          "Verify storage quota is not exceeded",
          "Try clearing browser storage and retry"
        ];
      case "REACT_NOT_AVAILABLE" /* REACT_NOT_AVAILABLE */:
        return [
          "Ensure React is properly installed and imported",
          "Check if you're using the hook in a React component"
        ];
      case "CRYPTO_PROVIDER_NOT_FOUND" /* CRYPTO_PROVIDER_NOT_FOUND */:
        return [
          "Check if the key type is supported",
          "Verify the crypto provider factory configuration"
        ];
      case "MULTIBASE_DECODE_FAILED" /* MULTIBASE_DECODE_FAILED */:
        return [
          "Verify the encoded string format is correct",
          "Check if the multibase prefix is valid",
          "Ensure the input is not corrupted"
        ];
      case "SCOPE_VALIDATION_FAILED" /* SCOPE_VALIDATION_FAILED */:
        return [
          "Check the scope format: address::module::function",
          "Verify the address format is valid",
          "Ensure module and function names are correct"
        ];
      case "DEEPLINK_INVALID_STATE" /* DEEPLINK_INVALID_STATE */:
        return [
          "Check if the state parameter matches the stored value",
          "Verify the callback URL parameters are correct",
          "Ensure the session storage is available"
        ];
      case "STORAGE_QUOTA_EXCEEDED" /* STORAGE_QUOTA_EXCEEDED */:
        return [
          "Clear unused data from browser storage",
          "Check available storage quota",
          "Consider using a different storage strategy"
        ];
      case "SIGNER_CONVERSION_FAILED" /* SIGNER_CONVERSION_FAILED */:
        return [
          "Verify the signer implements the required interface",
          "Check if the key ID is available in the signer",
          "Ensure the DID account signer is properly configured"
        ];
      default:
        return [];
    }
  }
};
function createConfigurationError(message, details, cause) {
  return new IdentityKitError("INVALID_CONFIGURATION" /* INVALID_CONFIGURATION */, message, {
    category: "configuration",
    details,
    cause
  });
}
function createDIDError(code, message, details, cause) {
  return new IdentityKitError(code, message, {
    category: "did",
    details,
    cause
  });
}
function createVDRError(code, message, details, cause) {
  return new IdentityKitError(code, message, {
    category: "vdr",
    details,
    cause
  });
}
function createKeyManagementError(code, message, details, cause) {
  return new IdentityKitError(code, message, {
    category: "key-management",
    details,
    cause
  });
}
function createAuthenticationError(code, message, details, cause) {
  return new IdentityKitError(code, message, {
    category: "authentication",
    details,
    cause
  });
}
function createWebError(code, message, details, cause) {
  return new IdentityKitError(code, message, {
    category: "web",
    details,
    cause
  });
}
function createReactError(code, message, details, cause) {
  return new IdentityKitError(code, message, {
    category: "react",
    details,
    cause
  });
}
function createCryptoError(code, message, details, cause) {
  return new IdentityKitError(code, message, {
    category: "crypto",
    details,
    cause
  });
}
function createMultibaseError(code, message, details, cause) {
  return new IdentityKitError(code, message, {
    category: "multibase",
    details,
    cause
  });
}
function createStorageError(code, message, details, cause) {
  return new IdentityKitError(code, message, {
    category: "storage",
    details,
    cause
  });
}
function createValidationError(code, message, details, cause) {
  return new IdentityKitError(code, message, {
    category: "validation",
    details,
    cause
  });
}
function createSignerError(code, message, details, cause) {
  return new IdentityKitError(code, message, {
    category: "signer",
    details,
    cause
  });
}
function createDeepLinkError(code, message, details, cause) {
  return new IdentityKitError(code, message, {
    category: "deeplink",
    details,
    cause
  });
}
function wrapUnknownError(error, context, code = "INTERNAL_ERROR" /* INTERNAL_ERROR */) {
  const originalError = error instanceof Error ? error : new Error(String(error));
  return new IdentityKitError(code, `${context}: ${originalError.message}`, {
    cause: originalError,
    details: { context }
  });
}
function isIdentityKitError(error) {
  return error instanceof IdentityKitError;
}
var AuthErrorCodeMapping = {
  INVALID_HEADER: "AUTH_INVALID_HEADER" /* AUTH_INVALID_HEADER */,
  INVALID_BASE64: "AUTH_INVALID_BASE64" /* AUTH_INVALID_BASE64 */,
  INVALID_JSON: "AUTH_INVALID_JSON" /* AUTH_INVALID_JSON */,
  MISSING_SIGNATURE: "AUTH_MISSING_SIGNATURE" /* AUTH_MISSING_SIGNATURE */,
  TIMESTAMP_OUT_OF_WINDOW: "AUTH_TIMESTAMP_OUT_OF_WINDOW" /* AUTH_TIMESTAMP_OUT_OF_WINDOW */,
  NONCE_REPLAYED: "AUTH_NONCE_REPLAYED" /* AUTH_NONCE_REPLAYED */,
  SIGNATURE_VERIFICATION_FAILED: "SIGNATURE_VERIFICATION_FAILED" /* SIGNATURE_VERIFICATION_FAILED */,
  DID_DOCUMENT_NOT_FOUND: "AUTH_DID_DOCUMENT_NOT_FOUND" /* AUTH_DID_DOCUMENT_NOT_FOUND */,
  VERIFICATION_METHOD_NOT_FOUND: "AUTH_VERIFICATION_METHOD_NOT_FOUND" /* AUTH_VERIFICATION_METHOD_NOT_FOUND */,
  INVALID_PUBLIC_KEY: "AUTH_INVALID_PUBLIC_KEY" /* AUTH_INVALID_PUBLIC_KEY */,
  DID_MISMATCH: "AUTH_DID_MISMATCH" /* AUTH_DID_MISMATCH */
};

// src/types/crypto.ts
var KeyType = /* @__PURE__ */ ((KeyType7) => {
  KeyType7["ED25519"] = "Ed25519VerificationKey2020";
  KeyType7["SECP256K1"] = "EcdsaSecp256k1VerificationKey2019";
  KeyType7["ECDSAR1"] = "EcdsaSecp256r1VerificationKey2019";
  return KeyType7;
})(KeyType || {});
var KEY_TYPE = KeyType;
function isKeyType(value) {
  return Object.values(KeyType).includes(value);
}
function toKeyType(value) {
  if (isKeyType(value)) {
    return value;
  }
  throw createValidationError(
    "KEY_TYPE_NOT_SUPPORTED" /* KEY_TYPE_NOT_SUPPORTED */,
    `Invalid key type: ${value}`,
    { value, supportedTypes: Object.values(KeyType) }
  );
}
function roochSignatureSchemeToKeyType(scheme) {
  if (scheme === "Secp256k1") {
    return "EcdsaSecp256k1VerificationKey2019" /* SECP256K1 */;
  } else if (scheme === "ED25519") {
    return "Ed25519VerificationKey2020" /* ED25519 */;
  } else if (scheme === "EcdsaR1") {
    return "EcdsaSecp256r1VerificationKey2019" /* ECDSAR1 */;
  }
  throw createValidationError(
    "KEY_TYPE_NOT_SUPPORTED" /* KEY_TYPE_NOT_SUPPORTED */,
    `Unsupported Rooch signature scheme: ${scheme}`,
    { scheme, supportedSchemes: ["Secp256k1", "ED25519", "EcdsaR1"] }
  );
}
function keyTypeToRoochSignatureScheme(keyType) {
  if (keyType === "EcdsaSecp256k1VerificationKey2019" /* SECP256K1 */) {
    return "Secp256k1";
  } else if (keyType === "Ed25519VerificationKey2020" /* ED25519 */) {
    return "ED25519";
  } else if (keyType === "EcdsaSecp256r1VerificationKey2019" /* ECDSAR1 */) {
    return "EcdsaR1";
  }
  throw createValidationError(
    "KEY_TYPE_NOT_SUPPORTED" /* KEY_TYPE_NOT_SUPPORTED */,
    `Unsupported key type: ${keyType}`,
    { keyType, supportedTypes: Object.values(KeyType) }
  );
}
function algorithmToKeyType(algorithm) {
  switch (algorithm) {
    case -8:
      return "Ed25519VerificationKey2020" /* ED25519 */;
    case -7:
      return "EcdsaSecp256r1VerificationKey2019" /* ECDSAR1 */;
    default:
      return void 0;
  }
}
function keyTypeToAlgorithm(keyType) {
  switch (keyType) {
    case "Ed25519VerificationKey2020" /* ED25519 */:
      return -8;
    case "EcdsaSecp256r1VerificationKey2019" /* ECDSAR1 */:
      return -7;
    default:
      return void 0;
  }
}
function getSupportedAlgorithms() {
  return [-8, -7];
}

// src/cache/InMemoryLRUDIDDocumentCache.ts
var InMemoryLRUDIDDocumentCache = class {
  constructor(maxEntries = 1e3) {
    this.capacity = maxEntries;
    this.map = /* @__PURE__ */ new Map();
  }
  get(did) {
    if (!this.map.has(did)) return void 0;
    const value = this.map.get(did) ?? null;
    this.map.delete(did);
    this.map.set(did, value);
    return value;
  }
  set(did, doc) {
    if (this.map.has(did)) {
      this.map.delete(did);
    } else if (this.map.size >= this.capacity) {
      const lruKey = this.map.keys().next().value;
      if (lruKey !== void 0) {
        this.map.delete(lruKey);
      }
    }
    this.map.set(did, doc);
  }
  has(did) {
    return this.map.has(did);
  }
  delete(did) {
    this.map.delete(did);
  }
  clear() {
    this.map.clear();
  }
};

// src/vdr/VDRRegistry.ts
var VDRRegistry = class _VDRRegistry {
  constructor() {
    this.vdrs = /* @__PURE__ */ new Map();
    this.cache = new InMemoryLRUDIDDocumentCache();
  }
  static getInstance() {
    if (!this.instance) {
      this.instance = new _VDRRegistry();
    }
    return this.instance;
  }
  /** Register a VDR implementation for its DID method (e.g., 'key', 'rooch'). */
  registerVDR(vdr) {
    this.vdrs.set(vdr.getMethod(), vdr);
  }
  /** Retrieve a previously registered VDR implementation by its method. */
  getVDR(method) {
    return this.vdrs.get(method);
  }
  /**
   * Override the default cache implementation.
   * This allows developers to provide their own cache (e.g., Redis, browser storage).
   */
  setCache(cache) {
    this.cache = cache;
  }
  /** Returns the currently configured cache instance. */
  getCache() {
    return this.cache;
  }
  async resolveDID(did, options) {
    const method = did.split(":")[1];
    const vdr = this.vdrs.get(method);
    if (!vdr) {
      throw createVDRError(
        "VDR_NOT_AVAILABLE" /* VDR_NOT_AVAILABLE */,
        `No VDR available for method: ${method}`,
        { method, availableMethods: Array.from(this.vdrs.keys()) }
      );
    }
    if (!options?.forceRefresh) {
      const cached = this.cache.get(did);
      if (cached !== void 0) {
        return cached;
      }
    }
    const resolved = await vdr.resolve(did);
    this.cache.set(did, resolved);
    return resolved;
  }
  async createDID(method, creationRequest, options) {
    const vdr = this.vdrs.get(method);
    if (!vdr) {
      throw createVDRError(
        "VDR_NOT_AVAILABLE" /* VDR_NOT_AVAILABLE */,
        `No VDR available for method: ${method}`,
        { method, availableMethods: Array.from(this.vdrs.keys()) }
      );
    }
    const result = await vdr.create(creationRequest, options);
    if (result.success && result.didDocument) {
      this.cache.set(result.didDocument.id, result.didDocument);
    }
    return result;
  }
  async createDIDViaCADOP(method, creationRequest, options) {
    const vdr = this.vdrs.get(method);
    if (!vdr) {
      throw createVDRError(
        "VDR_NOT_AVAILABLE" /* VDR_NOT_AVAILABLE */,
        `No VDR available for method: ${method}`,
        { method, availableMethods: Array.from(this.vdrs.keys()) }
      );
    }
    const result = await vdr.createViaCADOP(creationRequest, options);
    if (result.success && result.didDocument) {
      this.cache.set(result.didDocument.id, result.didDocument);
    }
    return result;
  }
  async createDIDViaCADOPWithController(method, creationRequest, options) {
    const vdr = this.vdrs.get(method);
    if (!vdr) {
      throw createVDRError(
        "VDR_NOT_AVAILABLE" /* VDR_NOT_AVAILABLE */,
        `No VDR available for method: ${method}`,
        { method, availableMethods: Array.from(this.vdrs.keys()) }
      );
    }
    const result = await vdr.createViaCADOPWithController(creationRequest, options);
    if (result.success && result.didDocument) {
      this.cache.set(result.didDocument.id, result.didDocument);
    }
    return result;
  }
  async exists(did) {
    const method = did.split(":")[1];
    const vdr = this.vdrs.get(method);
    if (!vdr) {
      throw createVDRError(
        "VDR_NOT_AVAILABLE" /* VDR_NOT_AVAILABLE */,
        `No VDR available for method: ${method}`,
        { method, availableMethods: Array.from(this.vdrs.keys()) }
      );
    }
    if (this.cache.has(did)) {
      const doc = this.cache.get(did);
      return doc !== null;
    }
    const exists = await vdr.exists(did);
    return exists;
  }
};

// src/multibase/base.ts
import { base58btc } from "multiformats/bases/base58";
import { base64pad, base64, base64url, base64urlpad } from "multiformats/bases/base64";
import { base16 } from "multiformats/bases/base16";

// src/utils/bytes.ts
function stringToBytes(str) {
  if (typeof TextEncoder !== "undefined") {
    return new TextEncoder().encode(str);
  }
  if (typeof Buffer !== "undefined" && typeof Buffer.from === "function") {
    return Uint8Array.from(Buffer.from(str, "utf-8"));
  }
  throw createValidationError(
    "ENVIRONMENT_NOT_SUPPORTED" /* ENVIRONMENT_NOT_SUPPORTED */,
    "No TextEncoder or Buffer available in this environment.",
    {
      environment: typeof globalThis,
      textEncoderAvailable: typeof TextEncoder !== "undefined",
      bufferAvailable: typeof Buffer !== "undefined"
    }
  );
}
function bytesToString(bytes) {
  if (typeof TextDecoder !== "undefined") {
    return new TextDecoder("utf-8").decode(bytes);
  }
  if (typeof Buffer !== "undefined" && typeof Buffer.from === "function") {
    return Buffer.from(bytes).toString("utf-8");
  }
  throw createValidationError(
    "ENVIRONMENT_NOT_SUPPORTED" /* ENVIRONMENT_NOT_SUPPORTED */,
    "No TextDecoder or Buffer available in this environment.",
    {
      environment: typeof globalThis,
      textDecoderAvailable: typeof TextDecoder !== "undefined",
      bufferAvailable: typeof Buffer !== "undefined"
    }
  );
}
function base64urlToBytes(base64url2) {
  const padding = base64url2.length % 4;
  const paddedBase64url = base64url2 + "=".repeat(padding === 0 ? 0 : 4 - padding);
  const base642 = paddedBase64url.replace(/-/g, "+").replace(/_/g, "/");
  const binaryString = atob(base642);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}
var Bytes = {
  stringToBytes,
  bytesToString,
  base64urlToBytes
};

// src/multibase/base.ts
var ENCODER_MAP = {
  base58btc,
  base64pad,
  base64,
  base64url,
  base64urlpad,
  base16
};
var MultibaseCodec = class {
  /**
   * Generic encode
   * Example: `MultibaseCodec.encode(bytes, 'base64url')`
   */
  static encode(data, base) {
    const encoder = ENCODER_MAP[base];
    if (!encoder) {
      throw createMultibaseError(
        "MULTIBASE_ENCODE_FAILED" /* MULTIBASE_ENCODE_FAILED */,
        `Unsupported multibase: ${base}`,
        { base, supportedBases: Object.keys(ENCODER_MAP) }
      );
    }
    const bytes = typeof data === "string" ? stringToBytes(data) : data;
    return encoder.encode(bytes);
  }
  /**
   * Encode bytes to base58btc format
   * @param bytes The bytes to encode
   * @returns base58btc encoded string with 'z' prefix
   */
  static encodeBase58btc(bytes) {
    return this.encode(bytes, "base58btc");
  }
  /**
   * Encode bytes to base64pad format
   * @param bytes The bytes to encode
   * @returns base64pad encoded string with 'M' prefix
   */
  static encodeBase64pad(data) {
    return this.encode(data, "base64pad");
  }
  /**
   * Encode bytes to base16 (hex) format
   * @param bytes The bytes to encode
   * @returns base16 encoded string with 'f' prefix
   */
  static encodeBase16(bytes) {
    return this.encode(bytes, "base16");
  }
  /**
   * Encode bytes to base64 format
   * @param bytes The bytes to encode
   * @returns base64 encoded string
   */
  static encodeBase64(data) {
    return this.encode(data, "base64");
  }
  /**
   * Encode bytes to base64url format (RFC4648 URL-safe, no padding)
   * @param bytes The bytes to encode
   * @returns base64url encoded string with 'u' prefix
   */
  static encodeBase64url(data) {
    return this.encode(data, "base64url");
  }
  /**
   * Encode bytes to base64urlpad format (URL-safe with padding)
   * @param bytes The bytes to encode
   * @returns base64urlpad encoded string with 'U' prefix
   */
  static encodeBase64urlpad(data) {
    return this.encode(data, "base64urlpad");
  }
  /**
   * Decode base58btc string to bytes
   * @param encoded The base58btc encoded string
   * @returns decoded bytes
   */
  static decodeBase58btc(encoded) {
    return base58btc.decode(encoded);
  }
  /**
   * Decode base64pad string to bytes
   * @param encoded The base64pad encoded string
   * @returns decoded bytes
   */
  static decodeBase64pad(encoded) {
    return base64pad.decode(encoded);
  }
  /**
   * Decode base16 string to bytes
   * @param encoded The base16 encoded string
   * @returns decoded bytes
   */
  static decodeBase16(encoded) {
    return base16.decode(encoded);
  }
  /**
   * Decode base64 string to bytes
   * @param encoded The base64 encoded string
   * @returns decoded bytes
   */
  static decodeBase64(encoded) {
    return base64.decode(encoded);
  }
  /**
   * Decode base64url string to bytes
   * @param encoded The base64url encoded string
   * @returns decoded bytes
   */
  static decodeBase64url(encoded) {
    return base64url.decode(encoded);
  }
  /**
   * Decode base64url string to string
   * @param encoded The base64url encoded string
   * @returns decoded string
   */
  static decodeBase64urlToString(encoded) {
    return bytesToString(this.decodeBase64url(encoded));
  }
  /**
   * Decode base64urlpad string to bytes
   * @param encoded The base64urlpad encoded string
   * @returns decoded bytes
   */
  static decodeBase64urlpad(encoded) {
    return base64urlpad.decode(encoded);
  }
  /**
   * Decode base64urlpad string to string
   * @param encoded The base64urlpad encoded string
   * @returns decoded string
   */
  static decodeBase64urlpadToString(encoded) {
    return bytesToString(this.decodeBase64urlpad(encoded));
  }
  /**
   * Decode multibase encoded string to bytes
   * After multiformats v9, there is no longer a single "universal base" object;
   * the official recommendation is to manually dispatch prefixes between the few *.decoder objects you use.
   * @param encoded The multibase encoded string
   * @returns decoded bytes
   */
  static decode(encoded) {
    const prefix = encoded[0];
    switch (prefix) {
      case "z":
        return base58btc.decode(encoded);
      case "M":
        return base64pad.decode(encoded);
      case "f":
        return base16.decode(encoded);
      case "m":
        return base64.decode(encoded);
      case "u":
        return base64url.decode(encoded);
      case "U":
        return base64urlpad.decode(encoded);
      default:
        throw createMultibaseError(
          "MULTIBASE_DECODE_FAILED" /* MULTIBASE_DECODE_FAILED */,
          `Unsupported multibase prefix: ${prefix}`,
          { prefix, supportedPrefixes: ["z", "M", "m", "u", "U", "f"] }
        );
    }
  }
};

// src/multibase/key.ts
var KeyMultibaseCodec = class {
  /**
   * Encode public key with multicodec prefix
   * @param bytes The public key bytes
   * @param keyType The key type
   * @returns multibase encoded string
   */
  static encodeWithType(bytes, keyType) {
    const expectedLength = this.getExpectedKeyLength(keyType);
    if (bytes.length !== expectedLength) {
      throw createValidationError(
        "INVALID_INPUT_FORMAT" /* INVALID_INPUT_FORMAT */,
        `Invalid key length for ${keyType}. Expected ${expectedLength} bytes, got ${bytes.length}`,
        { keyType, expectedLength, actualLength: bytes.length }
      );
    }
    const prefix = this.getMulticodecPrefix(keyType);
    const prefixedKey = this.concatenateBytes(prefix, bytes);
    return MultibaseCodec.encodeBase58btc(prefixedKey);
  }
  /**
   * Decode multibase encoded key
   * @param encoded The multibase encoded string
   * @returns The key type and public key bytes
   */
  static decodeWithType(encoded) {
    try {
      const decoded = MultibaseCodec.decodeBase58btc(encoded);
      if (decoded.length < 2) {
        throw createMultibaseError(
          "MULTIBASE_DECODE_FAILED" /* MULTIBASE_DECODE_FAILED */,
          "Invalid key format: too short",
          { encoded, minimumLength: 2, actualLength: decoded.length }
        );
      }
      const keyType = this.extractKeyType(decoded);
      const bytes = this.extractBytes(decoded);
      const expectedLength = this.getExpectedKeyLength(keyType);
      if (bytes.length !== expectedLength) {
        throw createValidationError(
          "INVALID_INPUT_FORMAT" /* INVALID_INPUT_FORMAT */,
          `Invalid key length for ${keyType}. Expected ${expectedLength} bytes, got ${bytes.length}`,
          { keyType, expectedLength, actualLength: bytes.length }
        );
      }
      return { keyType, bytes };
    } catch (error) {
      if (error instanceof Error && error.message === "Non-base58btc character") {
        throw createMultibaseError(
          "MULTIBASE_DECODE_FAILED" /* MULTIBASE_DECODE_FAILED */,
          "Invalid multibase format",
          { encoded }
        );
      }
      throw error;
    }
  }
  static getMulticodecPrefix(keyType) {
    switch (keyType) {
      case KEY_TYPE.ED25519:
        return this.ED25519_PREFIX;
      case KEY_TYPE.SECP256K1:
        return this.SECP256K1_PREFIX;
      case KEY_TYPE.ECDSAR1:
        return this.ECDSA_R1_PREFIX;
      default:
        throw createValidationError(
          "KEY_TYPE_NOT_SUPPORTED" /* KEY_TYPE_NOT_SUPPORTED */,
          `Unsupported key type: ${keyType}`,
          { keyType, supportedTypes: [KEY_TYPE.ED25519, KEY_TYPE.SECP256K1, KEY_TYPE.ECDSAR1] }
        );
    }
  }
  static concatenateBytes(a, b) {
    const result = new Uint8Array(a.length + b.length);
    result.set(a);
    result.set(b, a.length);
    return result;
  }
  static extractKeyType(prefixedBytes) {
    if (prefixedBytes[0] === 237 && prefixedBytes[1] === 1) {
      return KEY_TYPE.ED25519;
    } else if (prefixedBytes[0] === 231 && prefixedBytes[1] === 1) {
      return KEY_TYPE.SECP256K1;
    } else if (prefixedBytes[0] === 18 && prefixedBytes[1] === 0) {
      return KEY_TYPE.ECDSAR1;
    }
    throw createMultibaseError(
      "MULTIBASE_DECODE_FAILED" /* MULTIBASE_DECODE_FAILED */,
      "Unknown key type prefix",
      { prefix: Array.from(prefixedBytes.slice(0, 2)) }
    );
  }
  static extractBytes(prefixedBytes) {
    return prefixedBytes.slice(2);
  }
  static getExpectedKeyLength(keyType) {
    switch (keyType) {
      case KEY_TYPE.ED25519:
        return this.ED25519_KEY_LENGTH;
      case KEY_TYPE.SECP256K1:
        return this.SECP256K1_KEY_LENGTH;
      case KEY_TYPE.ECDSAR1:
        return this.ECDSA_R1_KEY_LENGTH;
      default:
        throw createValidationError(
          "KEY_TYPE_NOT_SUPPORTED" /* KEY_TYPE_NOT_SUPPORTED */,
          `Unsupported key type: ${keyType}`,
          { keyType, supportedTypes: [KEY_TYPE.ED25519, KEY_TYPE.SECP256K1, KEY_TYPE.ECDSAR1] }
        );
    }
  }
};
KeyMultibaseCodec.ED25519_PREFIX = new Uint8Array([237, 1]);
KeyMultibaseCodec.SECP256K1_PREFIX = new Uint8Array([231, 1]);
KeyMultibaseCodec.ECDSA_R1_PREFIX = new Uint8Array([18, 0]);
KeyMultibaseCodec.ED25519_KEY_LENGTH = 32;
KeyMultibaseCodec.SECP256K1_KEY_LENGTH = 33;
KeyMultibaseCodec.ECDSA_R1_KEY_LENGTH = 33;

// src/multibase/did.ts
var DidKeyCodec = class {
  /**
   * Generate did:key from public key
   * @param publicKey The public key bytes
   * @param keyType The key type
   * @returns did:key identifier
   */
  static generateDidKey(publicKey, keyType) {
    const multibase = KeyMultibaseCodec.encodeWithType(publicKey, keyType);
    return `did:key:${multibase}`;
  }
  /**
   * Parse did:key to get key type and public key
   * @param didKey The did:key identifier
   * @returns The key type and public key bytes
   */
  static parseDidKey(didKey) {
    if (!didKey.startsWith("did:key:")) {
      throw createDIDError("DID_INVALID_FORMAT" /* DID_INVALID_FORMAT */, "Invalid did:key format", {
        didKey,
        expectedPrefix: "did:key:"
      });
    }
    const multibase = didKey.substring(8);
    const { keyType, bytes } = KeyMultibaseCodec.decodeWithType(multibase);
    return { keyType, publicKey: bytes };
  }
};

// src/utils/did.ts
function parseDid(did) {
  if (!did.startsWith("did:")) {
    throw createDIDError("DID_INVALID_FORMAT" /* DID_INVALID_FORMAT */, `Invalid DID: ${did}`, {
      did,
      reason: 'DID must start with "did:"'
    });
  }
  const afterPrefix = did.slice(4);
  const methodEnd = afterPrefix.indexOf(":");
  if (methodEnd === -1) {
    throw createDIDError(
      "DID_INVALID_FORMAT" /* DID_INVALID_FORMAT */,
      `Invalid DID \u2013 missing method/identifier separator: ${did}`,
      { did, reason: 'Missing method/identifier separator ":"' }
    );
  }
  const method = afterPrefix.slice(0, methodEnd);
  const idPlusFrag = afterPrefix.slice(methodEnd + 1);
  if (!method || !idPlusFrag) {
    throw createDIDError("DID_INVALID_FORMAT" /* DID_INVALID_FORMAT */, `Invalid DID: ${did}`, {
      did,
      reason: "Empty method or identifier"
    });
  }
  const hashIdx = idPlusFrag.indexOf("#");
  return hashIdx === -1 ? { method, identifier: idPlusFrag } : {
    method,
    identifier: idPlusFrag.slice(0, hashIdx),
    fragment: idPlusFrag.slice(hashIdx + 1)
  };
}
function extractMethod(did) {
  return parseDid(did).method;
}
function extractIdentifier(did) {
  return parseDid(did).identifier;
}
function extractFragment(idOrDid) {
  const idx = idOrDid.indexOf("#");
  if (idx === -1) {
    throw createDIDError(
      "DID_INVALID_FORMAT" /* DID_INVALID_FORMAT */,
      `No fragment found in ${idOrDid}`,
      { idOrDid, reason: 'Missing fragment separator "#"' }
    );
  }
  return idOrDid.slice(idx + 1);
}
var extractFragmentFromId = extractFragment;
function buildDid(method, identifier) {
  return `did:${method}:${identifier}`;
}
function sameDid(a, b) {
  const pa = parseDid(a);
  const pb = parseDid(b);
  return pa.method === pb.method && pa.identifier === pb.identifier;
}
function getDidWithoutFragment(did) {
  const { method, identifier } = parseDid(did);
  return buildDid(method, identifier);
}

// src/utils/DebugLogger.ts
var LEVEL_ORDER = {
  debug: 10,
  info: 20,
  warn: 30,
  error: 40,
  silent: 50
};
function detectInitialGlobalLevel() {
  if (typeof process !== "undefined" && process.env) {
    const envLevel = process.env.NUWA_LOG_LEVEL;
    if (envLevel && envLevel in LEVEL_ORDER) return envLevel;
  }
  if (typeof window !== "undefined" && window.__NUWA_LOG_LEVEL__) {
    const envLevel = window.__NUWA_LOG_LEVEL__;
    if (envLevel && envLevel in LEVEL_ORDER) return envLevel;
  }
  return "info";
}
var _DebugLogger = class _DebugLogger {
  constructor(namespace) {
    this.namespace = namespace;
    this.levelOverridden = false;
    this.level = _DebugLogger.globalLevel;
  }
  /** Acquire (or create) a logger for the given namespace. */
  static get(namespace) {
    if (!_DebugLogger.loggers.has(namespace)) {
      _DebugLogger.loggers.set(namespace, new _DebugLogger(namespace));
    }
    return _DebugLogger.loggers.get(namespace);
  }
  /** Override global log level at runtime. */
  static setGlobalLevel(level) {
    _DebugLogger.globalLevel = level;
    for (const logger3 of _DebugLogger.loggers.values()) {
      if (!logger3.levelOverridden) {
        logger3.level = level;
      }
    }
  }
  /** Read current global level. */
  static getGlobalLevel() {
    return _DebugLogger.globalLevel;
  }
  /** Set default namespace used by static convenience methods. */
  static setDefaultNamespace(namespace) {
    _DebugLogger.defaultNamespace = namespace;
  }
  // ---------------------------------------------------------------------------
  // Static convenience logging methods
  // ---------------------------------------------------------------------------
  /**
   * Log using the default namespace. Useful when callers don't need per-module loggers.
   * Example: DebugLogger.debug('hello')
   */
  static debug(...args) {
    _DebugLogger.get(_DebugLogger.defaultNamespace).debug(...args);
  }
  static info(...args) {
    _DebugLogger.get(_DebugLogger.defaultNamespace).info(...args);
  }
  static warn(...args) {
    _DebugLogger.get(_DebugLogger.defaultNamespace).warn(...args);
  }
  static error(...args) {
    _DebugLogger.get(_DebugLogger.defaultNamespace).error(...args);
  }
  /** Override level for this logger only. */
  setLevel(level) {
    this.level = level;
    this.levelOverridden = true;
  }
  // -------------------------------------------------------
  // Logging helpers
  // -------------------------------------------------------
  debug(...args) {
    this._log("debug", args);
  }
  info(...args) {
    this._log("info", args);
  }
  warn(...args) {
    this._log("warn", args);
  }
  error(...args) {
    this._log("error", args);
  }
  // prettier-ignore
  _log(level, args) {
    if (LEVEL_ORDER[level] < LEVEL_ORDER[this.level]) {
      return;
    }
    const prefix = `[${this.namespace}]`;
    switch (level) {
      case "debug":
        console.debug(prefix, ...args);
        break;
      case "info":
        console.info(prefix, ...args);
        break;
      case "warn":
        console.warn(prefix, ...args);
        break;
      case "error":
        console.error(prefix, ...args);
        break;
    }
  }
};
// ---------------------------------------------------------------------------
// Static section
// ---------------------------------------------------------------------------
_DebugLogger.globalLevel = detectInitialGlobalLevel();
_DebugLogger.loggers = /* @__PURE__ */ new Map();
_DebugLogger.defaultNamespace = "global";
var DebugLogger = _DebugLogger;

// src/vdr/abstractVDR.ts
var logger = DebugLogger.get("AbstractVDR");
var AbstractVDR = class {
  /**
   * Creates a new AbstractVDR instance
   *
   * @param method The DID method this VDR handles
   */
  constructor(method) {
    this.method = method;
  }
  /**
   * Gets the DID method this VDR handles
   *
   * @returns The DID method string
   */
  getMethod() {
    return this.method;
  }
  /**
   * Validates that a given DID matches the method this VDR handles
   *
   * @param did The DID to validate
   * @throws Error if the DID doesn't match this VDR's method
   */
  validateDIDMethod(did) {
    const parsedDid = parseDid(did);
    if (parsedDid.method !== this.method) {
      throw createDIDError(
        "DID_INVALID_FORMAT" /* DID_INVALID_FORMAT */,
        `DID ${did} is not a valid did:${this.method} identifier`,
        { did, expectedMethod: this.method, actualMethod: parsedDid.method }
      );
    }
  }
  /**
   * Validates a DID document's basic structure
   *
   * @param document The DID document to validate
   * @returns true if valid, throws an error otherwise
   */
  validateDocument(document) {
    if (!document.id) {
      throw createValidationError(
        "VALIDATION_FAILED" /* VALIDATION_FAILED */,
        "DID document must have an id",
        { document }
      );
    }
    this.validateDIDMethod(document.id);
    if (!document["@context"]) {
      throw createValidationError(
        "VALIDATION_FAILED" /* VALIDATION_FAILED */,
        "DID document must have a @context property",
        { document }
      );
    }
    if (!document.verificationMethod || document.verificationMethod.length === 0) {
      throw createValidationError(
        "VALIDATION_FAILED" /* VALIDATION_FAILED */,
        "DID document must have at least one verification method",
        { document }
      );
    }
    return true;
  }
  /**
   * Check if a key has a specific verification relationship in a DID document
   *
   * @param didDocument The DID document to check
   * @param keyId The ID of the verification method
   * @param relationship The verification relationship to check
   * @returns True if the key has the relationship
   */
  hasVerificationRelationship(didDocument, keyId, relationship) {
    const relationshipArray = didDocument[relationship];
    if (!relationshipArray) return false;
    return relationshipArray.some((item) => {
      if (typeof item === "string") {
        return item === keyId;
      } else if (typeof item === "object" && item.id) {
        return item.id === keyId;
      }
      return false;
    });
  }
  /**
   * Validates if a key has permission to perform an operation
   *
   * @param didDocument The DID document
   * @param keyId The ID of the key
   * @param requiredRelationship The required verification relationship
   * @returns True if the key has permission
   */
  validateKeyPermission(didDocument, keyId, requiredRelationship) {
    const keyExists = didDocument.verificationMethod?.some((vm) => vm.id === keyId);
    if (!keyExists) {
      logger.error(`Key ${keyId} not found in DID document`);
      return false;
    }
    const isPrimaryKey = didDocument.verificationMethod?.[0]?.id === keyId;
    if (isPrimaryKey) {
      return true;
    }
    const hasPermission = didDocument[requiredRelationship]?.includes(keyId);
    if (!hasPermission) {
      logger.error(`Key ${keyId} does not have ${requiredRelationship} permission`);
      return false;
    }
    return true;
  }
  /**
   * Default create implementation - throws not implemented error for base class
   * Subclasses must override this method to provide actual implementation
   */
  async create(request, options) {
    throw createVDRError(
      "OPERATION_NOT_SUPPORTED" /* OPERATION_NOT_SUPPORTED */,
      `create method not implemented for ${this.method} VDR`,
      { method: this.method, operation: "create" }
    );
  }
  /**
   * Default CADOP implementation - throws not implemented error
   */
  async createViaCADOP(request, options) {
    throw createVDRError(
      "OPERATION_NOT_SUPPORTED" /* OPERATION_NOT_SUPPORTED */,
      `createViaCADOP not implemented for ${this.method} VDR`,
      { method: this.method, operation: "createViaCADOP" }
    );
  }
  /**
   * Default CADOP with controller implementation - throws not implemented error
   */
  async createViaCADOPWithController(request, options) {
    throw createVDRError(
      "OPERATION_NOT_SUPPORTED" /* OPERATION_NOT_SUPPORTED */,
      `createViaCADOPWithController not implemented for ${this.method} VDR`,
      { method: this.method, operation: "createViaCADOPWithController" }
    );
  }
  /**
   * Build DID Document from creation request
   */
  buildDIDDocumentFromRequest(request) {
    const did = request.preferredDID;
    const controllerForVM = Array.isArray(request.controller) ? request.controller[0] : request.controller || did;
    const verificationMethod = {
      id: `${did}#account-key`,
      type: request.keyType || "EcdsaSecp256k1VerificationKey2019",
      controller: controllerForVM,
      publicKeyMultibase: request.publicKeyMultibase
    };
    const didDocument = {
      "@context": ["https://www.w3.org/ns/did/v1"],
      id: did,
      controller: request.controller ? Array.isArray(request.controller) ? request.controller : [request.controller] : [did],
      verificationMethod: [verificationMethod, ...request.additionalVerificationMethods || []],
      service: request.initialServices || []
    };
    const relationships = request.initialRelationships || [
      "authentication",
      "assertionMethod",
      "capabilityInvocation",
      "capabilityDelegation"
    ];
    const vmId = verificationMethod.id;
    relationships.forEach((rel) => {
      if (!didDocument[rel]) {
        didDocument[rel] = [];
      }
      didDocument[rel].push(vmId);
    });
    return didDocument;
  }
  /**
   * Checks if a DID exists in the registry
   * Default implementation tries to resolve and checks if result is not null
   */
  async exists(did) {
    try {
      const doc = await this.resolve(did);
      return doc !== null;
    } catch (error) {
      return false;
    }
  }
  /**
   * Add a verification method to a DID document
   * Default implementation that should be overridden by specific VDR implementations
   */
  async addVerificationMethod(did, verificationMethod, relationships, options) {
    throw createVDRError(
      "OPERATION_NOT_SUPPORTED" /* OPERATION_NOT_SUPPORTED */,
      `addVerificationMethod not implemented for ${this.method} VDR`,
      { method: this.method, operation: "addVerificationMethod" }
    );
  }
  /**
   * Remove a verification method from a DID document
   * Default implementation that should be overridden by specific VDR implementations
   */
  async removeVerificationMethod(did, id, options) {
    throw createVDRError(
      "OPERATION_NOT_SUPPORTED" /* OPERATION_NOT_SUPPORTED */,
      `removeVerificationMethod not implemented for ${this.method} VDR`,
      { method: this.method, operation: "removeVerificationMethod" }
    );
  }
  /**
   * Add a service to a DID document
   * Default implementation that should be overridden by specific VDR implementations
   */
  async addService(did, service, options) {
    throw createVDRError(
      "OPERATION_NOT_SUPPORTED" /* OPERATION_NOT_SUPPORTED */,
      `addService not implemented for ${this.method} VDR`,
      { method: this.method, operation: "addService" }
    );
  }
  /**
   * Remove a service from a DID document
   * Default implementation that should be overridden by specific VDR implementations
   */
  async removeService(did, id, options) {
    throw createVDRError(
      "OPERATION_NOT_SUPPORTED" /* OPERATION_NOT_SUPPORTED */,
      `removeService not implemented for ${this.method} VDR`,
      { method: this.method, operation: "removeService" }
    );
  }
  /**
   * Update verification relationships for a verification method
   * Default implementation that should be overridden by specific VDR implementations
   */
  async updateRelationships(did, id, add, remove, options) {
    throw createVDRError(
      "OPERATION_NOT_SUPPORTED" /* OPERATION_NOT_SUPPORTED */,
      `updateRelationships not implemented for ${this.method} VDR`,
      { method: this.method, operation: "updateRelationships" }
    );
  }
  /**
   * Update the controller of a DID document
   * Default implementation that should be overridden by specific VDR implementations
   */
  async updateController(did, controller, options) {
    throw createVDRError(
      "OPERATION_NOT_SUPPORTED" /* OPERATION_NOT_SUPPORTED */,
      `updateController not implemented for ${this.method} VDR`,
      { method: this.method, operation: "updateController" }
    );
  }
  /**
   * Validates options for update operations and ensures proper permissions
   *
   * @param did The DID being operated on
   * @param document The resolved DID document
   * @param keyId The key ID used for signing
   * @param requiredRelationship The required verification relationship for this operation
   * @throws Error if validation fails
   */
  async validateUpdateOperation(did, document, keyId, requiredRelationship) {
    this.validateDIDMethod(did);
    if (!document) {
      throw createDIDError("DID_NOT_FOUND" /* DID_NOT_FOUND */, `DID document ${did} not found`, {
        did,
        operation: "validateUpdateOperation"
      });
    }
    if (!this.validateKeyPermission(document, keyId, requiredRelationship)) {
      throw createValidationError(
        "KEY_PERMISSION_DENIED" /* KEY_PERMISSION_DENIED */,
        `Key ${keyId} does not have ${requiredRelationship} permission required for this operation`,
        { keyId, requiredRelationship, did }
      );
    }
    return document;
  }
  /**
   * Validates that inputs to addVerificationMethod are correct
   *
   * @param did The DID being operated on
   * @param verificationMethod The verification method to validate
   * @param document The current DID document
   * @throws Error if validation fails
   */
  validateVerificationMethod(did, verificationMethod, document) {
    if (!verificationMethod.id.startsWith(did)) {
      throw createValidationError(
        "VALIDATION_FAILED" /* VALIDATION_FAILED */,
        `Verification method ID ${verificationMethod.id} must start with DID ${did}`,
        { verificationMethodId: verificationMethod.id, did }
      );
    }
    if (document.verificationMethod?.some((vm) => vm.id === verificationMethod.id)) {
      throw createValidationError(
        "VALIDATION_FAILED" /* VALIDATION_FAILED */,
        `Verification method ${verificationMethod.id} already exists`,
        { verificationMethodId: verificationMethod.id, did }
      );
    }
    if (!verificationMethod.type) {
      throw createValidationError(
        "VALIDATION_FAILED" /* VALIDATION_FAILED */,
        "Verification method must have a type",
        { verificationMethod, did }
      );
    }
    if (!verificationMethod.controller) {
      throw createValidationError(
        "VALIDATION_FAILED" /* VALIDATION_FAILED */,
        "Verification method must have a controller",
        { verificationMethod, did }
      );
    }
    if (!verificationMethod.publicKeyMultibase && !verificationMethod.publicKeyJwk) {
      throw createValidationError(
        "VALIDATION_FAILED" /* VALIDATION_FAILED */,
        "Verification method must have at least one form of public key material",
        { verificationMethod, did }
      );
    }
  }
  /**
   * Validates that inputs to addService are correct
   *
   * @param did The DID being operated on
   * @param service The service to validate
   * @param document The current DID document
   * @throws Error if validation fails
   */
  validateService(did, service, document) {
    if (!service.id.startsWith(did)) {
      throw createValidationError(
        "VALIDATION_FAILED" /* VALIDATION_FAILED */,
        `Service ID ${service.id} must start with DID ${did}`,
        { serviceId: service.id, did }
      );
    }
    if (document.service?.some((s) => s.id === service.id)) {
      throw createValidationError(
        "VALIDATION_FAILED" /* VALIDATION_FAILED */,
        `Service ${service.id} already exists`,
        { serviceId: service.id, did }
      );
    }
    if (!service.type) {
      throw createValidationError(
        "VALIDATION_FAILED" /* VALIDATION_FAILED */,
        "Service must have a type",
        { service, did }
      );
    }
    if (!service.serviceEndpoint) {
      throw createValidationError(
        "VALIDATION_FAILED" /* VALIDATION_FAILED */,
        "Service must have a serviceEndpoint",
        { service, did }
      );
    }
  }
  /**
   * Makes a deep copy of a DID document for modification
   *
   * @param document The DID document to copy
   * @returns A deep copy of the document
   */
  copyDocument(document) {
    return JSON.parse(JSON.stringify(document));
  }
};

// src/vdr/keyVDR.ts
var logger2 = DebugLogger.get("KeyVDR");
var _KeyVDR = class _KeyVDR extends AbstractVDR {
  constructor() {
    super("key");
  }
  /**
   * Resets the document cache - primarily for testing purposes
   * to ensure tests don't interfere with each other.
   */
  reset() {
    _KeyVDR.documentCache.clear();
  }
  /**
   * Override resolve to handle test mode
   */
  async resolve(did) {
    try {
      if (_KeyVDR.documentCache.has(did)) {
        return _KeyVDR.documentCache.get(did);
      }
      return null;
    } catch (error) {
      logger2.error(`Error resolving ${did}:`, error);
      return null;
    }
  }
  /**
   * Add a verification method to a did:key document
   * For did:key, this is mostly a simulation as the document is derived from the key
   * This operation will update the local cache but not the actual structure of the did:key
   *
   * @param did The DID to update
   * @param verificationMethod The verification method to add
   * @param relationships Optional relationships to add the verification method to
   * @param options Additional options like keyId for signing
   * @returns Promise resolving to true if successful in updating the cache
   */
  async addVerificationMethod(did, verificationMethod, relationships = [], options) {
    try {
      const originalDocument = await this.resolve(did);
      if (!originalDocument) {
        throw createDIDError("DID_NOT_FOUND" /* DID_NOT_FOUND */, `DID ${did} not found`, { did });
      }
      await this.validateUpdateOperation(
        did,
        originalDocument,
        options?.keyId,
        "capabilityDelegation"
      );
      this.validateVerificationMethod(did, verificationMethod, originalDocument);
      if (originalDocument.verificationMethod?.some((vm) => vm.id === verificationMethod.id)) {
        throw createValidationError(
          "VALIDATION_FAILED" /* VALIDATION_FAILED */,
          `Verification method ${verificationMethod.id} already exists`,
          { verificationMethodId: verificationMethod.id, did }
        );
      }
      if (!originalDocument.verificationMethod) {
        originalDocument.verificationMethod = [];
      }
      originalDocument.verificationMethod.push(verificationMethod);
      relationships.forEach((relationship) => {
        if (!originalDocument[relationship]) {
          originalDocument[relationship] = [];
        }
        if (!originalDocument[relationship].includes(verificationMethod.id)) {
          originalDocument[relationship].push(verificationMethod.id);
        }
      });
      _KeyVDR.documentCache.set(did, originalDocument);
      return true;
    } catch (error) {
      logger2.error(`Error adding verification method to ${did}:`, error);
      throw error;
    }
  }
  /**
   * Remove a verification method from a did:key document
   * For did:key, this is mostly a simulation as the document is derived from the key
   * This operation will update the local cache but not the actual structure of the did:key
   *
   * @param did The DID to update
   * @param keyId The ID of the verification method to remove
   * @param options Additional options
   * @returns Promise resolving to true if successful in updating the cache
   */
  async removeVerificationMethod(did, keyId, options) {
    try {
      const originalDocument = await this.resolve(did);
      if (!originalDocument) {
        throw createDIDError("DID_NOT_FOUND" /* DID_NOT_FOUND */, `DID ${did} not found`, { did });
      }
      await this.validateUpdateOperation(
        did,
        originalDocument,
        options?.keyId,
        "capabilityDelegation"
      );
      const verificationMethods = originalDocument.verificationMethod || [];
      const vmIndex = verificationMethods.findIndex((vm) => vm.id === keyId);
      if (vmIndex === -1) {
        return true;
      }
      const isPrimaryKey = vmIndex === 0;
      if (isPrimaryKey) {
        throw createValidationError(
          "OPERATION_NOT_PERMITTED" /* OPERATION_NOT_PERMITTED */,
          `Cannot remove the primary key ${keyId} from did:key document`,
          { keyId, did, reason: "Primary key cannot be removed from did:key documents" }
        );
      }
      originalDocument.verificationMethod = verificationMethods.filter((vm) => vm.id !== keyId);
      const relationships = [
        "authentication",
        "assertionMethod",
        "capabilityInvocation",
        "capabilityDelegation"
      ];
      relationships.forEach((relationship) => {
        if (originalDocument[relationship]) {
          originalDocument[relationship] = originalDocument[relationship].filter(
            (id) => id !== keyId
          );
        }
      });
      _KeyVDR.documentCache.set(did, originalDocument);
      return true;
    } catch (error) {
      logger2.error(`Error removing verification method from ${did}:`, error);
      throw error;
    }
  }
  /**
   * Add a service to a did:key document
   * For did:key, this is mostly a simulation as the document is derived from the key
   * This operation will update the local cache but not the actual structure of the did:key
   *
   * @param did The DID to update
   * @param service The service to add
   * @param options Additional options
   * @returns Promise resolving to true if successful in updating the cache
   */
  async addService(did, service, options) {
    try {
      const originalDocument = await this.resolve(did);
      if (!originalDocument) {
        throw createDIDError("DID_NOT_FOUND" /* DID_NOT_FOUND */, `DID ${did} not found`, { did });
      }
      await this.validateUpdateOperation(
        did,
        originalDocument,
        options?.keyId,
        "capabilityInvocation"
      );
      this.validateService(did, service, originalDocument);
      if (!originalDocument.service) {
        originalDocument.service = [];
      }
      originalDocument.service.push(service);
      _KeyVDR.documentCache.set(did, originalDocument);
      return true;
    } catch (error) {
      logger2.error(`Error adding service to ${did}:`, error);
      throw error;
    }
  }
  /**
   * Remove a service from a did:key document
   * For did:key, this is mostly a simulation as the document is derived from the key
   * This operation will update the local cache but not the actual structure of the did:key
   *
   * @param did The DID to update
   * @param id The ID of the service to remove
   * @param options Additional options
   * @returns Promise resolving to true if successful in updating the cache
   */
  async removeService(did, serviceId, options) {
    try {
      const originalDocument = await this.resolve(did);
      if (!originalDocument) {
        throw createDIDError("DID_NOT_FOUND" /* DID_NOT_FOUND */, `DID ${did} not found`, { did });
      }
      await this.validateUpdateOperation(
        did,
        originalDocument,
        options?.keyId,
        "capabilityInvocation"
      );
      if (!originalDocument.service || !originalDocument.service.some((s) => s.id === serviceId)) {
        return true;
      }
      originalDocument.service = originalDocument.service.filter((s) => s.id !== serviceId);
      _KeyVDR.documentCache.set(did, originalDocument);
      return true;
    } catch (error) {
      logger2.error(`Error removing service from ${did}:`, error);
      throw error;
    }
  }
  /**
   * Override create method for did:key
   * For did:key, we can generate the DID from the public key
   */
  async create(request) {
    try {
      if (!request.publicKeyMultibase || !request.publicKeyMultibase.startsWith("z")) {
        return {
          success: false,
          error: 'Invalid key format: publicKeyMultibase must start with "z"'
        };
      }
      if (!request.preferredDID || !request.controller) {
        return {
          success: false,
          error: "Missing required parameters: preferredDID and controller"
        };
      }
      const didDocument = this.buildDIDDocumentFromRequest(request);
      _KeyVDR.documentCache.set(request.preferredDID, didDocument);
      return {
        success: true,
        didDocument
      };
    } catch (error) {
      logger2.error(`Error creating DID document:`, error);
      return {
        success: false,
        error: error instanceof Error ? error.message : "Unknown error"
      };
    }
  }
  async createViaCADOP(request, _options) {
    let { keyType, publicKey } = DidKeyCodec.parseDidKey(request.userDidKey);
    try {
      const didCreationRequest = {
        publicKeyMultibase: MultibaseCodec.encodeBase58btc(publicKey),
        preferredDID: request.userDidKey,
        keyType,
        controller: request.userDidKey,
        initialRelationships: ["authentication", "capabilityDelegation"]
      };
      const didDocument = this.buildDIDDocumentFromRequest(didCreationRequest);
      _KeyVDR.documentCache.set(didDocument.id, didDocument);
      return {
        success: true,
        didDocument
      };
    } catch (error) {
      logger2.error(`Error creating DID document via CADOP:`, error);
      return {
        success: false,
        error: error instanceof Error ? error.message : "Unknown error"
      };
    }
  }
  async createViaCADOPWithController(request, _options) {
    if (!request.controllerDid.startsWith("did:key:")) {
      return {
        success: false,
        error: "KeyVDR only supports did:key controllers. Use RoochVDR for other controller types."
      };
    }
    try {
      const cadopRequest = {
        userDidKey: request.controllerDid,
        custodianServicePublicKey: request.custodianServicePublicKey,
        custodianServiceVMType: request.custodianServiceVMType,
        customScopes: request.customScopes
      };
      return this.createViaCADOP(cadopRequest, _options);
    } catch (error) {
      logger2.error(`Error creating DID document via CADOP with controller:`, error);
      return {
        success: false,
        error: error instanceof Error ? error.message : "Unknown error"
      };
    }
  }
  /**
   * Update verification relationships for a verification method
   */
  async updateRelationships(did, keyId, add, remove, options) {
    try {
      const originalDocument = await this.resolve(did);
      if (!originalDocument) {
        throw createDIDError("DID_NOT_FOUND" /* DID_NOT_FOUND */, `DID ${did} not found`, { did });
      }
      await this.validateUpdateOperation(
        did,
        originalDocument,
        options?.keyId,
        "capabilityDelegation"
      );
      const verificationMethod = originalDocument.verificationMethod?.find((vm) => vm.id === keyId);
      if (!verificationMethod) {
        throw createValidationError(
          "KEY_NOT_FOUND" /* KEY_NOT_FOUND */,
          `Verification method ${keyId} not found`,
          { keyId, did }
        );
      }
      remove.forEach((relationship) => {
        if (originalDocument[relationship]) {
          originalDocument[relationship] = originalDocument[relationship].filter(
            (id) => id !== keyId
          );
        }
      });
      add.forEach((relationship) => {
        if (!originalDocument[relationship]) {
          originalDocument[relationship] = [];
        }
        if (!originalDocument[relationship].includes(keyId)) {
          originalDocument[relationship].push(keyId);
        }
      });
      _KeyVDR.documentCache.set(did, originalDocument);
      return true;
    } catch (error) {
      logger2.error(`Error updating relationships for ${did}:`, error);
      throw error;
    }
  }
};
// In-memory cache of documents, shared across all instances
_KeyVDR.documentCache = /* @__PURE__ */ new Map();
var KeyVDR = _KeyVDR;

// src/vdr/roochVDR.ts
import {
  RoochClient,
  Transaction as Transaction2,
  Args,
  getRoochNodeUrl as sdkGetRoochNodeUrl
} from "@roochnetwork/rooch-sdk";

// src/crypto/providers/ed25519.ts
function getCrypto() {
  if (typeof globalThis !== "undefined" && globalThis.crypto) {
    return globalThis.crypto;
  }
  throw createCryptoError(
    "ENVIRONMENT_NOT_SUPPORTED" /* ENVIRONMENT_NOT_SUPPORTED */,
    "Web Crypto API is not available in the current runtime",
    { environment: typeof globalThis, cryptoAvailable: false }
  );
}
var Ed25519Provider = class {
  constructor() {
    this.crypto = getCrypto();
  }
  async generateKeyPair() {
    const generated = await this.crypto.subtle.generateKey(
      {
        name: "Ed25519"
      },
      true,
      ["sign", "verify"]
    );
    if (!("publicKey" in generated)) {
      throw createCryptoError(
        "CRYPTO_OPERATION_FAILED" /* CRYPTO_OPERATION_FAILED */,
        "Ed25519 generateKey did not return a key pair",
        { keyType: "Ed25519", operation: "generateKeyPair" }
      );
    }
    const { publicKey, privateKey } = generated;
    const exportedPublic = new Uint8Array(await this.crypto.subtle.exportKey("raw", publicKey));
    const exportedPrivate = new Uint8Array(await this.crypto.subtle.exportKey("pkcs8", privateKey));
    return {
      publicKey: exportedPublic,
      privateKey: exportedPrivate
    };
  }
  async sign(data, privateKey) {
    let key;
    if (privateKey instanceof Uint8Array) {
      key = await this.crypto.subtle.importKey(
        "pkcs8",
        privateKey,
        {
          name: "Ed25519"
        },
        false,
        ["sign"]
      );
    } else {
      key = privateKey;
    }
    const signature = await this.crypto.subtle.sign("Ed25519", key, data);
    return new Uint8Array(signature);
  }
  async verify(data, signature, publicKey) {
    let key;
    if (publicKey instanceof Uint8Array) {
      key = await this.crypto.subtle.importKey(
        "raw",
        publicKey,
        {
          name: "Ed25519"
        },
        false,
        ["verify"]
      );
    } else {
      key = await this.crypto.subtle.importKey(
        "jwk",
        publicKey,
        {
          name: "Ed25519"
        },
        false,
        ["verify"]
      );
    }
    return await this.crypto.subtle.verify("Ed25519", key, signature, data);
  }
  getKeyType() {
    return KEY_TYPE.ED25519;
  }
  async derivePublicKey(privateKey) {
    const cryptoKey = await this.crypto.subtle.importKey(
      "pkcs8",
      privateKey,
      { name: "Ed25519" },
      true,
      ["sign"]
    );
    const jwk = await this.crypto.subtle.exportKey("jwk", cryptoKey);
    if (!jwk.x) {
      throw createCryptoError(
        "CRYPTO_KEY_DERIVATION_FAILED" /* CRYPTO_KEY_DERIVATION_FAILED */,
        "Failed to derive public key from private key",
        { keyType: "Ed25519", operation: "derivePublicKey" }
      );
    }
    const publicKeyBytes = base64urlToBytes(jwk.x);
    return publicKeyBytes;
  }
};

// src/crypto/providers/secp256k1.ts
import { secp256k1 } from "@noble/curves/secp256k1";
import { sha256 } from "@noble/hashes/sha256";
var Secp256k1Provider = class {
  async generateKeyPair() {
    const privateKey = secp256k1.utils.randomPrivateKey();
    const publicKey = secp256k1.getPublicKey(privateKey, true);
    return {
      publicKey,
      privateKey
    };
  }
  async sign(data, privateKey) {
    if (privateKey instanceof CryptoKey) {
      throw createCryptoError(
        "OPERATION_NOT_SUPPORTED" /* OPERATION_NOT_SUPPORTED */,
        "CryptoKey is not supported for Secp256k1 signing",
        { keyType: "Secp256k1", operation: "sign", privateKeyType: "CryptoKey" }
      );
    }
    const msgHash = sha256(data);
    const signature = secp256k1.sign(msgHash, privateKey);
    return signature.toCompactRawBytes();
  }
  async verify(data, signature, publicKey) {
    if (!(publicKey instanceof Uint8Array)) {
      throw createCryptoError(
        "OPERATION_NOT_SUPPORTED" /* OPERATION_NOT_SUPPORTED */,
        "JsonWebKey is not supported for Secp256k1 verification",
        { keyType: "Secp256k1", operation: "verify", publicKeyType: "JsonWebKey" }
      );
    }
    const msgHash = sha256(data);
    return secp256k1.verify(signature, msgHash, publicKey);
  }
  getKeyType() {
    return KEY_TYPE.SECP256K1;
  }
  async derivePublicKey(privateKey) {
    return secp256k1.getPublicKey(privateKey, true);
  }
};

// src/crypto/providers/ecdsa_r1.ts
import { p256 } from "@noble/curves/p256";
import { bytesToHex, hexToBytes } from "@noble/curves/abstract/utils";
function getCrypto2() {
  if (typeof globalThis !== "undefined" && globalThis.crypto) {
    return globalThis.crypto;
  }
  throw createCryptoError(
    "ENVIRONMENT_NOT_SUPPORTED" /* ENVIRONMENT_NOT_SUPPORTED */,
    "Web Crypto API is not available in the current runtime",
    { environment: typeof globalThis, cryptoAvailable: false }
  );
}
var EcdsaR1Provider = class {
  constructor() {
    this.crypto = getCrypto2();
  }
  async generateKeyPair() {
    const generated = await this.crypto.subtle.generateKey(
      {
        name: "ECDSA",
        namedCurve: "P-256"
      },
      true,
      ["sign", "verify"]
    );
    if (!("publicKey" in generated)) {
      throw createCryptoError(
        "CRYPTO_OPERATION_FAILED" /* CRYPTO_OPERATION_FAILED */,
        "ECDSA P-256 generateKey did not return a key pair",
        { keyType: "ECDSA-R1", operation: "generateKeyPair" }
      );
    }
    const { publicKey, privateKey } = generated;
    const exportedPublic = new Uint8Array(await this.crypto.subtle.exportKey("raw", publicKey));
    const exportedPrivate = new Uint8Array(await this.crypto.subtle.exportKey("pkcs8", privateKey));
    const compressedPublicKey = this.compressPublicKey(exportedPublic);
    return {
      publicKey: compressedPublicKey,
      privateKey: exportedPrivate
    };
  }
  compressPublicKey(publicKey) {
    if (publicKey.length !== 65) {
      throw createValidationError(
        "INVALID_INPUT_FORMAT" /* INVALID_INPUT_FORMAT */,
        `Invalid public key length. Expected 65 bytes, got ${publicKey.length}`,
        { expectedLength: 65, actualLength: publicKey.length, keyType: "ECDSA-R1" }
      );
    }
    if (publicKey[0] !== 4) {
      throw createValidationError(
        "INVALID_INPUT_FORMAT" /* INVALID_INPUT_FORMAT */,
        "Invalid public key format. Expected uncompressed format (0x04)",
        { actualPrefix: publicKey[0], expectedPrefix: 4, keyType: "ECDSA-R1" }
      );
    }
    const x = publicKey.slice(1, 33);
    const y = publicKey.slice(33, 65);
    const compressedFormat = y[31] % 2 === 0 ? 2 : 3;
    const compressed = new Uint8Array(33);
    compressed[0] = compressedFormat;
    compressed.set(x, 1);
    return compressed;
  }
  decompressPublicKey(compressedKey) {
    if (compressedKey.length !== 33) {
      throw createValidationError(
        "INVALID_INPUT_FORMAT" /* INVALID_INPUT_FORMAT */,
        `Invalid compressed public key length. Expected 33 bytes, got ${compressedKey.length}`,
        { expectedLength: 33, actualLength: compressedKey.length, keyType: "ECDSA-R1" }
      );
    }
    const format = compressedKey[0];
    if (format !== 2 && format !== 3) {
      throw createValidationError(
        "INVALID_INPUT_FORMAT" /* INVALID_INPUT_FORMAT */,
        "Invalid compressed public key format. Expected 0x02 or 0x03",
        { actualPrefix: compressedKey[0], expectedPrefixes: [2, 3], keyType: "ECDSA-R1" }
      );
    }
    try {
      const point = p256.ProjectivePoint.fromHex(compressedKey);
      const x = point.x;
      const y = point.y;
      const xBytes = hexToBytes(x.toString(16).padStart(64, "0"));
      const yBytes = hexToBytes(y.toString(16).padStart(64, "0"));
      const decompressed = new Uint8Array(65);
      decompressed[0] = 4;
      decompressed.set(xBytes, 1);
      decompressed.set(yBytes, 33);
      return decompressed;
    } catch (err) {
      const error = err;
      throw createCryptoError(
        "CRYPTO_OPERATION_FAILED" /* CRYPTO_OPERATION_FAILED */,
        `Failed to decompress public key: ${error.message}`,
        { keyType: "ECDSA-R1", operation: "decompressPublicKey", originalError: error.message }
      );
    }
  }
  async sign(data, privateKey) {
    let key;
    if (privateKey instanceof Uint8Array) {
      key = await this.crypto.subtle.importKey(
        "pkcs8",
        privateKey,
        {
          name: "ECDSA",
          namedCurve: "P-256"
        },
        false,
        ["sign"]
      );
    } else {
      key = privateKey;
    }
    const signature = await this.crypto.subtle.sign(
      {
        name: "ECDSA",
        hash: { name: "SHA-256" }
      },
      key,
      data
    );
    return new Uint8Array(signature);
  }
  convertDERSignatureToRaw(derSignature) {
    const firstByte = derSignature[0];
    if (firstByte === 48) {
      try {
        const sig = p256.Signature.fromDER(derSignature);
        return sig.toCompactRawBytes();
      } catch (e) {
        throw createValidationError(
          "INVALID_INPUT_FORMAT" /* INVALID_INPUT_FORMAT */,
          "Invalid DER signature",
          { keyType: "ECDSA-R1", operation: "parseDERSignature" }
        );
      }
    }
    return derSignature;
  }
  convertRawToDER(raw) {
    if (raw.length !== 64) return raw;
    const r = bytesToHex(raw.slice(0, 32));
    const s = bytesToHex(raw.slice(32, 64));
    const der = p256.Signature.fromCompact(hexToBytes(r + s)).toDERHex();
    return hexToBytes(der);
  }
  async verify(data, signature, publicKey) {
    let key;
    if (publicKey instanceof Uint8Array) {
      const decompressedKey = this.decompressPublicKey(publicKey);
      key = await this.crypto.subtle.importKey(
        "raw",
        decompressedKey,
        {
          name: "ECDSA",
          namedCurve: "P-256"
        },
        false,
        ["verify"]
      );
    } else {
      key = await this.crypto.subtle.importKey(
        "jwk",
        publicKey,
        {
          name: "ECDSA",
          namedCurve: "P-256"
        },
        false,
        ["verify"]
      );
    }
    return await this.crypto.subtle.verify(
      {
        name: "ECDSA",
        hash: { name: "SHA-256" }
      },
      key,
      signature,
      data
    );
  }
  getKeyType() {
    return KEY_TYPE.ECDSAR1;
  }
  async derivePublicKey(privateKey) {
    const cryptoKey = await this.crypto.subtle.importKey(
      "pkcs8",
      privateKey,
      { name: "ECDSA", namedCurve: "P-256" },
      true,
      ["sign"]
    );
    const jwk = await this.crypto.subtle.exportKey("jwk", cryptoKey);
    if (!jwk.x || !jwk.y) {
      throw createCryptoError(
        "CRYPTO_KEY_DERIVATION_FAILED" /* CRYPTO_KEY_DERIVATION_FAILED */,
        "Failed to derive public key from private key",
        { keyType: "ECDSA-R1", operation: "derivePublicKey" }
      );
    }
    const x = base64urlToBytes(jwk.x);
    const y = base64urlToBytes(jwk.y);
    const uncompressed = new Uint8Array(65);
    uncompressed[0] = 4;
    uncompressed.set(x, 1);
    uncompressed.set(y, 33);
    return this.compressPublicKey(uncompressed);
  }
};

// src/crypto/factory.ts
var DefaultCryptoProviderFactory = class {
  constructor() {
    this.providers = /* @__PURE__ */ new Map();
    this.providers.set(KEY_TYPE.ED25519, new Ed25519Provider());
    this.providers.set(KEY_TYPE.SECP256K1, new Secp256k1Provider());
    this.providers.set(KEY_TYPE.ECDSAR1, new EcdsaR1Provider());
  }
  createProvider(keyType) {
    const provider = this.providers.get(keyType);
    if (!provider) {
      throw createCryptoError(
        "CRYPTO_PROVIDER_NOT_FOUND" /* CRYPTO_PROVIDER_NOT_FOUND */,
        `No provider available for key type: ${keyType}`,
        { keyType, availableTypes: Array.from(this.providers.keys()) }
      );
    }
    return provider;
  }
  supports(keyType) {
    return this.providers.has(keyType);
  }
};
var defaultCryptoProviderFactory = new DefaultCryptoProviderFactory();

// src/crypto/utils.ts
var CryptoUtils = class {
  /**
   * Generates a key pair based on the specified curve
   * @param type The key type to generate (Ed25519VerificationKey2020 or EcdsaSecp256k1VerificationKey2019 or EcdsaSecp256r1VerificationKey2019)
   * @returns A key pair containing public and private keys
   */
  static async generateKeyPair(type = "Ed25519VerificationKey2020" /* ED25519 */) {
    const keyType = typeof type === "string" ? toKeyType(type) : type;
    const provider = defaultCryptoProviderFactory.createProvider(keyType);
    return provider.generateKeyPair();
  }
  /**
   * Signs data using the specified private key
   * @param data The data to sign
   * @param privateKey The private key to use for signing (can be Uint8Array or CryptoKey)
   * @param type The key type (Ed25519VerificationKey2020 or EcdsaSecp256k1VerificationKey2019)
   * @returns The signature as a Uint8Array
   */
  static async sign(data, privateKey, type) {
    const keyType = typeof type === "string" ? toKeyType(type) : type;
    const provider = defaultCryptoProviderFactory.createProvider(keyType);
    return provider.sign(data, privateKey);
  }
  /**
   * Verifies a signature using the specified public key
   * @param data The original data
   * @param signature The signature to verify
   * @param publicKey The public key to use for verification (can be Uint8Array or JsonWebKey)
   * @param type The key type (Ed25519VerificationKey2020 or EcdsaSecp256k1VerificationKey2019)
   * @returns Whether the signature is valid
   */
  static async verify(data, signature, publicKey, type) {
    const keyType = typeof type === "string" ? toKeyType(type) : type;
    const provider = defaultCryptoProviderFactory.createProvider(keyType);
    return provider.verify(data, signature, publicKey);
  }
  /**
   * Derive public key from private key
   * @param privateKey The private key bytes
   * @param keyType The key type
   * @returns The corresponding public key bytes
   */
  static async derivePublicKey(privateKey, keyType) {
    const type = typeof keyType === "string" ? toKeyType(keyType) : keyType;
    const provider = defaultCryptoProviderFactory.createProvider(type);
    return provider.derivePublicKey(privateKey);
  }
  /**
   * Validate the consistency between a private key and public key pair
   * @param privateKey The private key bytes
   * @param publicKey The public key bytes
   * @param keyType The key type
   * @returns true if the keys are consistent, false otherwise
   */
  static async validateKeyPairConsistency(privateKey, publicKey, keyType) {
    try {
      const derivedPublicKey = await this.derivePublicKey(privateKey, keyType);
      return this.areUint8ArraysEqual(derivedPublicKey, publicKey);
    } catch (error) {
      console.warn("Key pair consistency validation failed:", error);
      return false;
    }
  }
  /**
   * Compare two Uint8Array for equality
   * @param a First array
   * @param b Second array
   * @returns true if arrays are equal, false otherwise
   */
  static areUint8ArraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
};

// src/crypto/EcdsaR1PublicKey.ts
import { p256 as p2562 } from "@noble/curves/p256";
import {
  RoochAddress,
  PublicKey,
  SIGNATURE_SCHEME_TO_FLAG,
  blake2b,
  fromB64
} from "@roochnetwork/rooch-sdk";
var PUBLIC_KEY_SIZE = 33;
var EcdsaR1PublicKey = class extends PublicKey {
  /**
   * Create a new EcdsaR1PublicKey object
   * @param value ECDSA R1 public key as buffer or base-64 encoded string
   */
  constructor(value) {
    super();
    if (typeof value === "string") {
      this.data = fromB64(value);
    } else if (value instanceof Uint8Array) {
      this.data = value;
    } else {
      this.data = Uint8Array.from(value);
    }
    if (this.data.length !== PUBLIC_KEY_SIZE) {
      throw createValidationError(
        "INVALID_INPUT_FORMAT" /* INVALID_INPUT_FORMAT */,
        `Invalid public key input. Expected ${PUBLIC_KEY_SIZE} bytes, got ${this.data.length}`,
        { expectedSize: PUBLIC_KEY_SIZE, actualSize: this.data.length, keyType: "ECDSA-R1" }
      );
    }
  }
  /**
   * Checks if two EcdsaR1 public keys are equal
   */
  equals(publicKey) {
    return super.equals(publicKey);
  }
  /**
   * Return the byte array representation of the ECDSA R1 public key
   */
  toBytes() {
    return this.data;
  }
  /**
   * Return the signature scheme flag for ECDSA R1
   */
  flag() {
    return SIGNATURE_SCHEME_TO_FLAG.EcdsaR1;
  }
  /**
   * Verifies that the signature is valid for the provided message
   */
  async verify(message, signature) {
    try {
      return p2562.verify(signature, message, this.toBytes());
    } catch (error) {
      return false;
    }
  }
  /**
   * Return the Rooch address associated with this ECDSA R1 public key
   */
  toAddress() {
    const tmp = new Uint8Array(PUBLIC_KEY_SIZE + 1);
    tmp.set([SIGNATURE_SCHEME_TO_FLAG.EcdsaR1]);
    tmp.set(this.toBytes(), 1);
    const ROOCH_ADDRESS_LENGTH = 32;
    return new RoochAddress(blake2b(tmp, { dkLen: 32 }).slice(0, ROOCH_ADDRESS_LENGTH * 2));
  }
};
EcdsaR1PublicKey.SIZE = PUBLIC_KEY_SIZE;

// src/signers/keyStoreUtils.ts
async function signWithKeyStore(keyStore, data, keyId) {
  if (typeof keyStore.sign === "function") {
    return keyStore.sign(keyId, data);
  }
  const key = await keyStore.load(keyId);
  if (!key) {
    throw createKeyManagementError("KEY_NOT_FOUND" /* KEY_NOT_FOUND */, `Key not found: ${keyId}`, {
      keyId
    });
  }
  if (!key.privateKeyMultibase) {
    throw createKeyManagementError(
      "KEY_PRIVATE_KEY_NOT_AVAILABLE" /* KEY_PRIVATE_KEY_NOT_AVAILABLE */,
      `No private key available for ${keyId}`,
      { keyId }
    );
  }
  const privateKeyBytes = MultibaseCodec.decode(key.privateKeyMultibase);
  return CryptoUtils.sign(data, privateKeyBytes, key.keyType);
}
async function canSignWithKeyStore(keyStore, keyId) {
  if (typeof keyStore.sign === "function") {
    const keyExists = await keyStore.load(keyId);
    return keyExists !== null;
  }
  const key = await keyStore.load(keyId);
  return !!(key && key.privateKeyMultibase);
}
async function getKeyInfoFromKeyStore(keyStore, keyId) {
  const key = await keyStore.load(keyId);
  if (!key) return void 0;
  const publicKeyBytes = MultibaseCodec.decode(key.publicKeyMultibase);
  return { type: key.keyType, publicKey: publicKeyBytes };
}

// src/signers/KeyStoreSigner.ts
var KeyStoreSigner = class {
  /**
   * Create a new KeyStoreSigner
   * @param keyStore The underlying key store to use
   * @param did The DID to associate with this signer
   */
  constructor(keyStore, did) {
    this.keyStore = keyStore;
    if (did) {
      this.did = did;
    }
  }
  /**
   * List all available key IDs in the underlying store
   */
  async listKeyIds() {
    return this.keyStore.listKeyIds();
  }
  /**
   * Sign data using a specific key
   * @param data Data to sign
   * @param keyId ID of the key to use for signing
   * @returns Signature as Uint8Array
   */
  async signWithKeyId(data, keyId) {
    return signWithKeyStore(this.keyStore, data, keyId);
  }
  /**
   * Check if a key is available for signing
   * @param keyId ID of the key to check
   * @returns True if the key exists and can be used for signing
   */
  async canSignWithKeyId(keyId) {
    return canSignWithKeyStore(this.keyStore, keyId);
  }
  /**
   * Get the DID associated with this signer.
   */
  async getDid() {
    if (this.did) return this.did;
    throw createKeyManagementError(
      "DID_NOT_SET" /* DID_NOT_SET */,
      "DID not initialised. setDid() must be called by KeyManager.",
      { operation: "getDid" }
    );
  }
  /**
   * Set the DID for this signer
   * @param did The DID to associate with this signer
   */
  setDid(did) {
    this.did = did;
  }
  /**
   * Get information about a specific key
   * @param keyId ID of the key to get information about
   * @returns Key information or undefined if not found
   */
  async getKeyInfo(keyId) {
    return getKeyInfoFromKeyStore(this.keyStore, keyId);
  }
};

// src/signers/types.ts
function isSignerInterface(obj) {
  return obj && typeof obj === "object" && typeof obj.listKeyIds === "function" && typeof obj.signWithKeyId === "function" && typeof obj.canSignWithKeyId === "function" && typeof obj.getDid === "function" && typeof obj.getKeyInfo === "function" && // Check that it's NOT a Signer (which has different methods)
  typeof obj.sign !== "function";
}

// src/signers/didAccountSigner.ts
import {
  RoochAddress as RoochAddress2,
  Signer,
  Authenticator,
  Ed25519PublicKey,
  Secp256k1PublicKey
} from "@roochnetwork/rooch-sdk";
var DidAccountSigner = class _DidAccountSigner extends Signer {
  constructor(wrappedSigner, did, keyId, keyType, publicKey) {
    super();
    this.wrappedSigner = wrappedSigner;
    this.__brandDidAccountSigner = true;
    this.keyId = keyId;
    this.did = did;
    if (!this.did.startsWith("did:rooch:")) {
      throw createSignerError(
        "SIGNER_INVALID_DID" /* SIGNER_INVALID_DID */,
        "Signer DID must be a did:rooch DID",
        { did: this.did, expectedMethod: "rooch" }
      );
    }
    const didParts = parseDid(did);
    this.didAddress = new RoochAddress2(didParts.identifier);
    this.keyType = keyType;
    this.publicKey = publicKey;
  }
  /**
   * Create a DidAccountSigner instance from a SignerInterface
   * @param signer The signer to wrap
   * @param keyId Optional specific keyId to use
   * @returns A new DidAccountSigner instance
   */
  /**
   * Check if an object is a DidAccountSigner instance
   * Safe to use instanceof within the same module
   */
  static isDidAccountSigner(obj) {
    return obj instanceof _DidAccountSigner;
  }
  static async create(signer, keyId) {
    if (_DidAccountSigner.isDidAccountSigner(signer)) {
      return signer;
    }
    const actualKeyId = keyId || (await signer.listKeyIds())[0];
    if (!actualKeyId) {
      throw createSignerError("SIGNER_NO_KEYS" /* SIGNER_NO_KEYS */, "No available keys in signer", {
        signer
      });
    }
    const keyInfo = await signer.getKeyInfo(actualKeyId);
    if (!keyInfo) {
      throw createSignerError(
        "KEY_NOT_FOUND" /* KEY_NOT_FOUND */,
        `Key info not found for keyId: ${actualKeyId}`,
        { keyId: actualKeyId, signer }
      );
    }
    const did = await signer.getDid();
    const didSigner = new _DidAccountSigner(
      signer,
      did,
      actualKeyId,
      keyInfo.type,
      keyInfo.publicKey
    );
    const maybeWebAuthn = signer;
    if (maybeWebAuthn && typeof maybeWebAuthn.signAssertion === "function") {
      didSigner.signAssertion = (challenge) => maybeWebAuthn.signAssertion(challenge);
    }
    return didSigner;
  }
  // Implement Rooch Signer interface
  getRoochAddress() {
    return this.didAddress;
  }
  async sign(input) {
    return this.wrappedSigner.signWithKeyId(input, this.keyId);
  }
  async signTransaction(input) {
    const txHash = input.hashData();
    const vmFragment = this.getVmFragment();
    return Authenticator.did(txHash, this, vmFragment);
  }
  getKeyScheme() {
    return keyTypeToRoochSignatureScheme(this.keyType);
  }
  getPublicKey() {
    if (this.keyType === "EcdsaSecp256k1VerificationKey2019" /* SECP256K1 */) {
      return new Secp256k1PublicKey(this.publicKey);
    } else if (this.keyType === "Ed25519VerificationKey2020" /* ED25519 */) {
      return new Ed25519PublicKey(this.publicKey);
    } else if (this.keyType === "EcdsaSecp256r1VerificationKey2019" /* ECDSAR1 */) {
      return new EcdsaR1PublicKey(this.publicKey);
    } else {
      throw createSignerError(
        "KEY_TYPE_NOT_SUPPORTED" /* KEY_TYPE_NOT_SUPPORTED */,
        `Unsupported key type: ${this.keyType}`,
        { keyType: this.keyType, supportedTypes: ["Ed25519", "Secp256k1", "EcdsaR1"] }
      );
    }
  }
  getBitcoinAddress() {
    throw createSignerError(
      "OPERATION_NOT_SUPPORTED" /* OPERATION_NOT_SUPPORTED */,
      "Bitcoin address is not supported for DID account",
      { operation: "getBitcoinAddress" }
    );
  }
  // Implement SignerInterface
  async signWithKeyId(data, keyId) {
    if (keyId !== this.keyId) {
      throw createValidationError(
        "KEY_ID_MISMATCH" /* KEY_ID_MISMATCH */,
        `Key ID mismatch. Expected ${this.keyId}, got ${keyId}`,
        { expectedKeyId: this.keyId, actualKeyId: keyId }
      );
    }
    return this.sign(data);
  }
  async canSignWithKeyId(keyId) {
    return keyId === this.keyId;
  }
  async listKeyIds() {
    return [this.keyId];
  }
  async getDid() {
    return this.did;
  }
  async getKeyInfo(keyId) {
    if (keyId !== this.keyId) {
      return void 0;
    }
    return {
      type: this.keyType,
      publicKey: this.publicKey
    };
  }
  getVmFragment() {
    const parts = this.keyId.split("#");
    if (parts.length !== 2) {
      throw createValidationError(
        "INVALID_INPUT_FORMAT" /* INVALID_INPUT_FORMAT */,
        `Invalid keyId format: ${this.keyId}. Expected format: "did:rooch:0x123#fragment"`,
        { keyId: this.keyId, expectedFormat: "did:rooch:0x123#fragment" }
      );
    }
    return parts[1];
  }
};
function isDidAccountSigner(obj) {
  return Boolean(obj && obj.__brandDidAccountSigner === true);
}

// src/vdr/roochVDRTypes.ts
import {
  bcs,
  sha3_256,
  toHEX,
  stringToBytes as stringToBytes2,
  Serializer
} from "@roochnetwork/rooch-sdk";
function simpleMapSchema(keySchema, valueSchema) {
  return bcs.struct("SimpleMap", {
    data: bcs.vector(
      bcs.struct("Entry", {
        key: keySchema,
        value: valueSchema
      })
    )
  });
}
function formatDIDString(did) {
  return `did:${did.method}:${did.identifier}`;
}
var DIDSchema = bcs.struct("DID", {
  method: bcs.string(),
  identifier: bcs.string()
});
var DIDIdSchema = bcs.struct("DIDID", {
  did: DIDSchema,
  fragment: bcs.string()
});
var VerificationMethodSchema = bcs.struct("VerificationMethod", {
  id: DIDIdSchema,
  type: bcs.string(),
  controller: DIDSchema,
  public_key_multibase: bcs.string()
});
var ServiceSchema = bcs.struct("Service", {
  id: DIDIdSchema,
  type: bcs.string(),
  service_endpoint: bcs.string(),
  properties: simpleMapSchema(bcs.string(), bcs.string())
});
var AccountCapSchema = bcs.struct("AccountCap", {
  addr: bcs.Address
});
var DIDDocumentSchema = bcs.struct("DIDDocument", {
  id: DIDSchema,
  controller: bcs.vector(DIDSchema),
  verification_methods: simpleMapSchema(bcs.string(), VerificationMethodSchema),
  authentication: bcs.vector(bcs.string()),
  assertion_method: bcs.vector(bcs.string()),
  capability_invocation: bcs.vector(bcs.string()),
  capability_delegation: bcs.vector(bcs.string()),
  key_agreement: bcs.vector(bcs.string()),
  services: simpleMapSchema(bcs.string(), ServiceSchema),
  also_known_as: bcs.vector(bcs.string()),
  account_cap: AccountCapSchema
});
var DIDCreatedEventSchema = bcs.struct("DIDCreatedEvent", {
  did: bcs.string(),
  object_id: bcs.ObjectId,
  controller: bcs.vector(bcs.string()),
  creator_address: bcs.Address
});
function simpleMapToMap(simpleMap) {
  return new Map(simpleMap.data.map((entry) => [entry.key, entry.value]));
}
function convertMoveDIDDocumentToInterface(didDocObject) {
  let bcsHex = didDocObject.value;
  bcsHex = bcsHex.startsWith("0x") ? bcsHex.slice(2) : bcsHex;
  let bcsBytes = new Uint8Array(
    bcsHex.match(/.{1,2}/g)?.map((byte) => parseInt(byte, 16)) || []
  );
  let didDoc = DIDDocumentSchema.parse(bcsBytes);
  const didId = formatDIDString(didDoc.id);
  const controllers = didDoc.controller.map((c) => formatDIDString(c));
  const verificationMethods = [];
  const verificationMethodsMap = simpleMapToMap(didDoc.verification_methods);
  verificationMethodsMap.forEach((vm) => {
    verificationMethods.push({
      id: `${formatDIDString(vm.id.did)}#${vm.id.fragment}`,
      type: vm.type,
      controller: formatDIDString(vm.controller),
      publicKeyMultibase: vm.public_key_multibase
    });
  });
  const convertFragmentToDIDURL = (fragment) => `${didId}#${fragment}`;
  const services = [];
  const servicesMap = simpleMapToMap(didDoc.services);
  servicesMap.forEach((service) => {
    const serviceEndpoint = {
      id: `${formatDIDString(service.id.did)}#${service.id.fragment}`,
      type: service.type,
      serviceEndpoint: service.service_endpoint
    };
    let properties = simpleMapToMap(service.properties);
    if (properties.size > 0) {
      Object.assign(serviceEndpoint, Object.fromEntries(properties));
    }
    services.push(serviceEndpoint);
  });
  return {
    "@context": ["https://www.w3.org/ns/did/v1"],
    id: didId,
    controller: controllers,
    verificationMethod: verificationMethods,
    authentication: didDoc.authentication.map(convertFragmentToDIDURL),
    assertionMethod: didDoc.assertion_method.map(convertFragmentToDIDURL),
    capabilityInvocation: didDoc.capability_invocation.map(convertFragmentToDIDURL),
    capabilityDelegation: didDoc.capability_delegation.map(convertFragmentToDIDURL),
    keyAgreement: didDoc.key_agreement.map(convertFragmentToDIDURL),
    service: services,
    alsoKnownAs: didDoc.also_known_as
  };
}
function parseDIDCreatedEvent(eventData) {
  const hexData = eventData.startsWith("0x") ? eventData.slice(2) : eventData;
  const bytes = new Uint8Array(
    hexData.match(/.{1,2}/g)?.map((byte) => parseInt(byte, 16)) || []
  );
  return DIDCreatedEventSchema.parse(bytes);
}
var DIDDocumentStructTag = {
  address: "0x3",
  module: "did",
  name: "DIDDocument",
  typeParams: []
};
function resolveDidObjectID(identifier) {
  return customObjectID(identifier, DIDDocumentStructTag);
}
function customObjectID(id, structTag) {
  const idBytes = bcs.String.serialize(id).toBytes();
  const typeBytes = stringToBytes2("utf8", Serializer.structTagToCanonicalString(structTag));
  const bytes = new Uint8Array(idBytes.length + typeBytes.length);
  bytes.set(idBytes);
  bytes.set(typeBytes, idBytes.length);
  const hash = sha3_256(bytes);
  return `0x${toHEX(hash)}`;
}

// src/utils/sessionScopes.ts
function buildBaseScopes() {
  return [
    "0x3::did::*",
    // DID contract - all functions
    "0x3::payment_channel::*",
    // Payment channel contract - all functions
    "0xeb1deb6f1190f86cd4e05a82cfa5775a8a5929da49fac3ab8f5bf23e9181e625::*::*"
    // Cap Registry contract - all functions
  ];
}
function combineScopes(customScopes = []) {
  const baseScopes = buildBaseScopes();
  const allScopes = [...baseScopes, ...customScopes];
  return Array.from(new Set(allScopes));
}
function validateScopeFormat(scope) {
  if (!scope || typeof scope !== "string") {
    return false;
  }
  const parts = scope.split("::");
  if (parts.length !== 3) {
    return false;
  }
  const [address2, module, func] = parts;
  if (!address2 || !module || !func) {
    return false;
  }
  if (address2 !== "*" && !isValidAddressFormat(address2)) {
    return false;
  }
  return true;
}
function validateScopes(scopes) {
  const invalidScopes = scopes.filter((scope) => !validateScopeFormat(scope));
  return {
    valid: invalidScopes.length === 0,
    invalidScopes
  };
}
function isValidAddressFormat(address2) {
  if (address2.startsWith("0x")) {
    return /^0x[0-9a-fA-F]+$/.test(address2);
  }
  if (address2.startsWith("rooch1")) {
    return /^rooch1[0-9a-z]+$/.test(address2);
  }
  return false;
}
function scopeObjectToString(scope) {
  return `${scope.address}::${scope.module}::${scope.func}`;
}
function scopeObjectsToStrings(scopes) {
  return scopes.map(scopeObjectToString);
}

// src/vdr/roochVDR.ts
var RoochVDR = class _RoochVDR extends AbstractVDR {
  constructor(options) {
    super("rooch");
    this.options = options;
    this.didContractAddress = "0x3::did";
    this.debug = options.debug || false;
    this.logger = DebugLogger.get("RoochVDR");
    if (this.debug) {
      this.logger.setLevel("debug");
    }
    let rpcUrl = options.rpcUrl;
    if (!rpcUrl) {
      rpcUrl = _RoochVDR.getRoochNodeUrl(options.network || "test");
    }
    this.logger.debug(`RoochVDR initialized with rpcUrl: ${rpcUrl}`);
    this.client = new RoochClient({ url: rpcUrl });
  }
  /**
   * Log message if debug mode is enabled
   */
  debugLog(message, data) {
    if (data !== void 0) {
      this.logger.debug(message, data);
    } else {
      this.logger.debug(message);
    }
  }
  /**
   * Log error message (always logged regardless of debug mode)
   */
  errorLog(message, error) {
    if (error !== void 0) {
      this.logger.error(message, error);
    } else {
      this.logger.error(message);
    }
  }
  async convertSigner(signer, keyId) {
    if (isSignerInterface(signer)) {
      return DidAccountSigner.create(signer, keyId);
    }
    return signer;
  }
  /**
   * Override create method to support Rooch dynamic DID generation
   */
  async create(request, options) {
    try {
      const signer = options?.signer;
      if (!signer) {
        throw createSignerError(
          "SIGNER_NOT_AVAILABLE" /* SIGNER_NOT_AVAILABLE */,
          "No signer provided for create operation",
          { operation: "create", request }
        );
      }
      this.debugLog("Creating DID with request:", request);
      const didAccountSigner = await this.convertSigner(signer, options?.keyId);
      const finalScopes = combineScopes(request.customScopes || []);
      const scopeValidation = validateScopes(finalScopes);
      if (!scopeValidation.valid) {
        throw createValidationError(
          "SCOPE_VALIDATION_FAILED" /* SCOPE_VALIDATION_FAILED */,
          `Invalid scope format: ${scopeValidation.invalidScopes.join(", ")}`,
          {
            invalidScopes: scopeValidation.invalidScopes,
            allScopes: finalScopes,
            operation: "create"
          }
        );
      }
      const transaction = this.createTransaction();
      transaction.callFunction({
        target: `${this.didContractAddress}::create_did_object_for_self_with_custom_scopes_entry`,
        args: [Args.string(request.publicKeyMultibase), Args.vec("string", finalScopes)],
        maxGas: options?.advanced?.maxGas || 1e8
      });
      this.debugLog("Creating DID with scopes:", finalScopes);
      this.debugLog("Creating DID Transaction:", transaction);
      const result = await this.client.signAndExecuteTransaction({
        transaction,
        signer: didAccountSigner,
        option: { withOutput: true }
      });
      const success = result.execution_info.status.type === "executed";
      if (!success) {
        return {
          success: false,
          error: "Transaction execution failed, execution_info: " + JSON.stringify(result.execution_info),
          debug: {
            requestedDID: request.preferredDID,
            transactionResult: result.execution_info
          }
        };
      }
      const didCreatedEvent = result.output?.events?.find(
        (event) => event.event_type === "0x3::did::DIDCreatedEvent"
      );
      if (!didCreatedEvent) {
        throw createVDRError(
          "VDR_INVALID_RESPONSE" /* VDR_INVALID_RESPONSE */,
          "DIDCreatedEvent not found in transaction result",
          { transactionResult: result, events: result.output?.events, operation: "create" }
        );
      }
      let actualDID = this.parseDIDCreatedEventAndGetDID(didCreatedEvent);
      this.lastCreatedDIDAddress = actualDID;
      let didDocument = await this.resolve(actualDID);
      if (!didDocument) {
        throw createVDRError(
          "DID_RESOLUTION_FAILED" /* DID_RESOLUTION_FAILED */,
          `DID document not found with DID: ${actualDID}`,
          { did: actualDID, operation: "create" }
        );
      }
      return {
        success: true,
        didDocument,
        transactionHash: result.transaction_hash,
        debug: {
          requestedDID: request.preferredDID,
          actualDID: actualDID || void 0,
          events: result.output?.events
        }
      };
    } catch (error) {
      this.errorLog("Error creating DID:", error);
      return {
        success: false,
        error: error instanceof Error ? error.message : "Unknown error"
      };
    }
  }
  /**
   * Override CADOP creation method
   */
  async createViaCADOP(request, options) {
    try {
      const signer = options?.signer;
      if (!signer) {
        throw createSignerError(
          "SIGNER_NOT_AVAILABLE" /* SIGNER_NOT_AVAILABLE */,
          "No custodian signer provided for CADOP operation",
          { operation: "createViaCADOP", request }
        );
      }
      this.debugLog("Creating DID via CADOP with request:", request);
      const didAccountSigner = await this.convertSigner(signer, options?.keyId);
      const finalScopes = combineScopes(request.customScopes || []);
      const scopeValidation = validateScopes(finalScopes);
      if (!scopeValidation.valid) {
        throw createValidationError(
          "SCOPE_VALIDATION_FAILED" /* SCOPE_VALIDATION_FAILED */,
          `Invalid scope format: ${scopeValidation.invalidScopes.join(", ")}`,
          {
            invalidScopes: scopeValidation.invalidScopes,
            allScopes: finalScopes,
            operation: "createViaCADOP"
          }
        );
      }
      const transaction = this.createTransaction();
      transaction.callFunction({
        target: `${this.didContractAddress}::create_did_object_via_cadop_with_did_key_and_scopes_entry`,
        args: [
          Args.string(request.userDidKey),
          Args.string(request.custodianServicePublicKey),
          Args.string(request.custodianServiceVMType),
          Args.vec("string", finalScopes)
        ],
        maxGas: options?.advanced?.maxGas || 1e8
      });
      this.debugLog("Creating DID via CADOP with scopes:", finalScopes);
      this.debugLog("Creating DID via CADOP Transaction:", transaction);
      const result = await this.client.signAndExecuteTransaction({
        transaction,
        signer: didAccountSigner,
        option: { withOutput: true }
      });
      this.debugLog("Creating DID via CADOP Transaction Result:", result);
      const success = result.execution_info.status.type === "executed";
      if (!success) {
        return {
          success: false,
          error: "CADOP transaction execution failed, execution_info: " + JSON.stringify(result.execution_info)
        };
      }
      const didCreatedEvent = result.output?.events?.find(
        (event) => event.event_type === "0x3::did::DIDCreatedEvent"
      );
      if (!didCreatedEvent) {
        throw createVDRError(
          "VDR_INVALID_RESPONSE" /* VDR_INVALID_RESPONSE */,
          "DIDCreatedEvent not found in transaction result",
          { transactionResult: result, events: result.output?.events }
        );
      }
      let actualDID = this.parseDIDCreatedEventAndGetDID(didCreatedEvent);
      let didDocument = await this.resolve(actualDID);
      if (!didDocument) {
        throw createVDRError(
          "DID_RESOLUTION_FAILED" /* DID_RESOLUTION_FAILED */,
          `DID document not found with DID: ${actualDID}`,
          { did: actualDID }
        );
      }
      return {
        success: true,
        didDocument,
        transactionHash: result.transaction_hash
      };
    } catch (error) {
      this.errorLog("Error creating DID via CADOP:", error);
      return {
        success: false,
        error: error instanceof Error ? error.message : "Unknown error"
      };
    }
  }
  /**
   * Create DID via CADOP with controller (supports did:key, did:bitcoin, etc.)
   */
  async createViaCADOPWithController(request, options) {
    try {
      const signer = options?.signer;
      if (!signer) {
        throw createSignerError(
          "SIGNER_NOT_AVAILABLE" /* SIGNER_NOT_AVAILABLE */,
          "No custodian signer provided for CADOP controller operation",
          { operation: "createViaCADOPWithController", request }
        );
      }
      this.debugLog("Creating DID via CADOP with controller request:", request);
      const didAccountSigner = await this.convertSigner(signer, options?.keyId);
      const finalScopes = combineScopes(request.customScopes || []);
      const scopeValidation = validateScopes(finalScopes);
      if (!scopeValidation.valid) {
        throw createValidationError(
          "SCOPE_VALIDATION_FAILED" /* SCOPE_VALIDATION_FAILED */,
          `Invalid scope format: ${scopeValidation.invalidScopes.join(", ")}`,
          {
            invalidScopes: scopeValidation.invalidScopes,
            allScopes: finalScopes,
            operation: "createViaCADOPWithController"
          }
        );
      }
      const transaction = this.createTransaction();
      transaction.callFunction({
        target: `${this.didContractAddress}::create_did_object_via_cadop_with_controller_and_scopes_entry`,
        args: [
          Args.string(request.controllerDid),
          Args.string(request.controllerPublicKeyMultibase || ""),
          Args.string(request.controllerVMType || ""),
          Args.string(request.custodianServicePublicKey),
          Args.string(request.custodianServiceVMType),
          Args.vec("string", finalScopes)
        ],
        maxGas: options?.advanced?.maxGas || 1e8
      });
      this.debugLog("Creating DID via CADOP with controller and scopes:", finalScopes);
      this.debugLog("Controller DID:", request.controllerDid);
      this.debugLog("Controller public key multibase:", request.controllerPublicKeyMultibase);
      this.debugLog("Controller VM type:", request.controllerVMType);
      this.debugLog("Creating DID via CADOP with controller Transaction:", transaction);
      const result = await this.client.signAndExecuteTransaction({
        transaction,
        signer: didAccountSigner,
        option: { withOutput: true }
      });
      this.debugLog("Creating DID via CADOP with controller Transaction Result:", result);
      const success = result.execution_info.status.type === "executed";
      if (!success) {
        return {
          success: false,
          error: "CADOP controller transaction execution failed, execution_info: " + JSON.stringify(result.execution_info)
        };
      }
      const didCreatedEvent = result.output?.events?.find(
        (event) => event.event_type === "0x3::did::DIDCreatedEvent"
      );
      if (!didCreatedEvent) {
        throw createVDRError(
          "VDR_INVALID_RESPONSE" /* VDR_INVALID_RESPONSE */,
          "DIDCreatedEvent not found in transaction result",
          { transactionResult: result, events: result.output?.events }
        );
      }
      let actualDID = this.parseDIDCreatedEventAndGetDID(didCreatedEvent);
      let didDocument = await this.resolve(actualDID);
      if (!didDocument) {
        throw createVDRError(
          "DID_RESOLUTION_FAILED" /* DID_RESOLUTION_FAILED */,
          `DID document not found with DID: ${actualDID}`,
          { did: actualDID }
        );
      }
      return {
        success: true,
        didDocument,
        transactionHash: result.transaction_hash,
        debug: {
          requestedDID: request.controllerDid,
          actualDID,
          events: result.output?.events
        }
      };
    } catch (error) {
      this.errorLog("Error creating DID via CADOP with controller:", error);
      return {
        success: false,
        error: error instanceof Error ? error.message : "Unknown error"
      };
    }
  }
  /**
   * Resolve DID Document from Rooch blockchain
   *
   * @param did The DID to resolve (e.g., "did:rooch:0x123...")
   * @returns Promise resolving to the DID Document or null if not found
   */
  async resolve(did) {
    try {
      this.validateDIDMethod(did);
      const { method, identifier } = parseDid(did);
      if (method !== "rooch") {
        throw createVDRError(
          "DID_INVALID_FORMAT" /* DID_INVALID_FORMAT */,
          "Invalid DID format. Expected did:rooch:address",
          { did, expectedMethod: "rooch", actualMethod: method }
        );
      }
      const objectId = resolveDidObjectID(identifier);
      this.debugLog(`Resolved DID object ID: ${objectId}`);
      const objectStates = await this.client.getObjectStates({
        ids: [objectId]
      });
      if (!objectStates || objectStates.length === 0) {
        return null;
      }
      let didDocObject = objectStates[0];
      if (!didDocObject) {
        this.debugLog(`Resolved DID document by ${did} is null`);
        return null;
      }
      return convertMoveDIDDocumentToInterface(didDocObject);
    } catch (error) {
      this.errorLog(`Error resolving DID from Rooch network:`, error);
      return null;
    }
  }
  /**
   * Check if a DID exists on the Rooch network
   *
   * @param did The DID to check
   * @returns Promise resolving to true if the DID exists
   */
  async exists(did) {
    try {
      this.validateDIDMethod(did);
      const { method, identifier } = parseDid(did);
      if (method !== "rooch") {
        return false;
      }
      const address2 = identifier;
      const result = await this.client.executeViewFunction({
        target: `${this.didContractAddress}::exists_did_for_address`,
        args: [Args.address(address2)]
      });
      return result?.vm_status === "Executed" && result.return_values?.[0]?.decoded_value === true;
    } catch (error) {
      this.errorLog(`Error checking DID existence on Rooch network:`, error);
      return false;
    }
  }
  /**
   * Add a verification method to a DID document on Rooch blockchain
   */
  async addVerificationMethod(did, verificationMethod, relationships, options) {
    try {
      this.validateDIDMethod(did);
      const signer = options?.signer;
      if (!signer) {
        throw createSignerError(
          "SIGNER_NOT_AVAILABLE" /* SIGNER_NOT_AVAILABLE */,
          "No signer provided for addVerificationMethod operation",
          { operation: "addVerificationMethod", did }
        );
      }
      const didAccountSigner = await this.convertSigner(signer, options?.keyId);
      const currentDoc = await this.resolve(did);
      if (!currentDoc) {
        throw createVDRError("DID_NOT_FOUND" /* DID_NOT_FOUND */, `DID document ${did} not found`, {
          did
        });
      }
      this.debugLog(`Adding verification method to DID: ${did}`);
      this.debugLog(
        `Using signer with address: ${didAccountSigner.getRoochAddress().toBech32Address()}`
      );
      const signerAddress = didAccountSigner.getRoochAddress ? didAccountSigner.getRoochAddress().toBech32Address() : null;
      if (signerAddress && !this.hasPermissionForOperation(currentDoc, signerAddress, "capabilityDelegation")) {
        this.errorLog(`Signer does not have capabilityDelegation permission for ${did}`);
        this.debugLog(
          `Note: DID operations may require the DID account itself to sign, not the controller`
        );
        return false;
      }
      if (!verificationMethod.publicKeyMultibase) {
        throw createValidationError(
          "INVALID_INPUT_FORMAT" /* INVALID_INPUT_FORMAT */,
          "Verification method must have publicKeyMultibase",
          { verificationMethod, did }
        );
      }
      const relationshipValues = this.convertVerificationRelationships(relationships || []);
      const hasAuthentication = relationships?.includes("authentication");
      const transaction = this.createTransaction();
      if (hasAuthentication) {
        const finalScopes = combineScopes(options?.scopes || []);
        const scopeValidation = validateScopes(finalScopes);
        if (!scopeValidation.valid) {
          throw createValidationError(
            "SCOPE_VALIDATION_FAILED" /* SCOPE_VALIDATION_FAILED */,
            `Invalid scope format: ${scopeValidation.invalidScopes.join(", ")}`,
            {
              invalidScopes: scopeValidation.invalidScopes,
              allScopes: finalScopes,
              operation: "addVerificationMethod"
            }
          );
        }
        transaction.callFunction({
          target: `${this.didContractAddress}::add_verification_method_with_scopes_entry`,
          args: [
            Args.string(extractFragmentFromId(verificationMethod.id)),
            Args.string(verificationMethod.type),
            Args.string(verificationMethod.publicKeyMultibase),
            Args.vec("u8", relationshipValues),
            Args.vec("string", finalScopes)
          ],
          maxGas: options?.advanced?.maxGas || 1e8
        });
        this.debugLog("Using add_verification_method_with_scopes_entry with scopes:", finalScopes);
      } else {
        transaction.callFunction({
          target: `${this.didContractAddress}::add_verification_method_entry`,
          args: [
            Args.string(extractFragmentFromId(verificationMethod.id)),
            Args.string(verificationMethod.type),
            Args.string(verificationMethod.publicKeyMultibase),
            Args.vec("u8", relationshipValues)
          ],
          maxGas: options?.advanced?.maxGas || 1e8
        });
        this.debugLog(
          "Using regular add_verification_method_entry (no authentication relationship)"
        );
      }
      this.debugLog(`Verification method transaction prepared`);
      this.debugLog(`Fragment:`, extractFragmentFromId(verificationMethod.id));
      this.debugLog(`Type:`, verificationMethod.type);
      this.debugLog(`Relationships:`, relationshipValues);
      const result = await this.client.signAndExecuteTransaction({
        transaction,
        signer: didAccountSigner,
        option: { withOutput: true }
      });
      this.debugLog(`Transaction execution result:`, {
        status: result.execution_info.status,
        gas_used: result.execution_info.gas_used,
        events_count: result.output?.events?.length || 0
      });
      if (result.execution_info.status.type !== "executed") {
        this.errorLog(`Transaction failed:`, result.execution_info);
        if (result.execution_info.status.type === "moveabort") {
          this.errorLog(`Move abort code:`, result.execution_info.status.abort_code);
          this.errorLog(`Move abort location:`, result.execution_info.status.location);
        }
        return false;
      }
      this.debugLog(`Verification method added successfully`);
      return true;
    } catch (error) {
      this.errorLog(`Error adding verification method to ${did}:`, error);
      return false;
    }
  }
  /**
   * Remove a verification method from a DID document on Rooch blockchain
   */
  async removeVerificationMethod(did, id, options) {
    try {
      this.validateDIDMethod(did);
      const signer = options?.signer;
      if (!signer) {
        throw createSignerError(
          "SIGNER_NOT_AVAILABLE" /* SIGNER_NOT_AVAILABLE */,
          "No signer provided for removeVerificationMethod operation",
          { operation: "removeVerificationMethod", did, id }
        );
      }
      const didAccountSigner = await this.convertSigner(signer, options?.keyId);
      const currentDoc = await this.resolve(did);
      if (!currentDoc) {
        throw createVDRError("DID_NOT_FOUND" /* DID_NOT_FOUND */, `DID document ${did} not found`, {
          did
        });
      }
      const signerAddress = didAccountSigner.getRoochAddress ? didAccountSigner.getRoochAddress().toBech32Address() : null;
      if (signerAddress && !this.hasPermissionForOperation(currentDoc, signerAddress, "capabilityDelegation")) {
        this.errorLog(`Signer does not have capabilityDelegation permission for ${did}`);
        return false;
      }
      const transaction = this.createTransaction();
      transaction.callFunction({
        target: `${this.didContractAddress}::remove_verification_method_entry`,
        args: [Args.string(extractFragmentFromId(id))],
        maxGas: options?.advanced?.maxGas || 1e8
      });
      const result = await this.client.signAndExecuteTransaction({
        transaction,
        signer: didAccountSigner,
        option: { withOutput: true }
      });
      return result.execution_info.status.type === "executed";
    } catch (error) {
      this.errorLog(`Error removing verification method from ${did}:`, error);
      return false;
    }
  }
  /**
   * Add a service to a DID document on Rooch blockchain
   */
  async addService(did, service, options) {
    try {
      this.validateDIDMethod(did);
      const signer = options?.signer;
      if (!signer) {
        throw createSignerError(
          "SIGNER_NOT_AVAILABLE" /* SIGNER_NOT_AVAILABLE */,
          "No signer provided for addService operation",
          { operation: "addService", did }
        );
      }
      const didAccountSigner = await this.convertSigner(signer, options?.keyId);
      const currentDoc = await this.resolve(did);
      if (!currentDoc) {
        throw createVDRError("DID_NOT_FOUND" /* DID_NOT_FOUND */, `DID document ${did} not found`, {
          did
        });
      }
      this.debugLog(`Adding service to DID: ${did}`);
      this.debugLog(
        `\u{1F5DD}\uFE0F Using signer with address: ${didAccountSigner.getRoochAddress().toBech32Address()}`
      );
      const signerAddress = didAccountSigner.getRoochAddress ? didAccountSigner.getRoochAddress().toBech32Address() : null;
      if (signerAddress && !this.hasPermissionForOperation(currentDoc, signerAddress, "capabilityInvocation")) {
        this.errorLog(`Signer does not have capabilityInvocation permission for ${did}`);
        this.debugLog(
          `\u{1F4A1} Note: DID operations may require the DID account itself to sign, not the controller`
        );
        return false;
      }
      const standardKeys = ["id", "type", "serviceEndpoint"];
      const additionalProperties = Object.entries(service).reduce(
        (acc, [key, value]) => {
          if (!standardKeys.includes(key)) {
            acc[key] = value ? value.toString() : "";
          }
          return acc;
        },
        {}
      );
      const propertyKeys = Object.keys(additionalProperties);
      const propertyValues = Object.values(additionalProperties).map(
        (value) => value ? value.toString() : ""
      );
      this.debugLog("service", service);
      this.debugLog("additionalProperties", additionalProperties);
      this.debugLog("propertyKeys", propertyKeys);
      this.debugLog("propertyValues", propertyValues);
      const transaction = this.createTransaction();
      transaction.callFunction({
        target: `${this.didContractAddress}::add_service_with_properties_entry`,
        args: [
          Args.string(extractFragmentFromId(service.id)),
          Args.string(service.type),
          Args.string(service.serviceEndpoint),
          Args.vec("string", propertyKeys),
          Args.vec("string", propertyValues)
        ],
        maxGas: options?.advanced?.maxGas || 1e8
      });
      this.debugLog("Executing transaction: add_service_entry");
      this.debugLog("Args:", [
        extractFragmentFromId(service.id),
        service.type,
        service.serviceEndpoint
      ]);
      const result = await this.client.signAndExecuteTransaction({
        transaction,
        signer: didAccountSigner,
        option: { withOutput: true }
      });
      this.debugLog("Transaction execution result:", {
        status: result.execution_info.status,
        gas_used: result.execution_info.gas_used,
        events_count: result.output?.events?.length || 0
      });
      if (result.execution_info.status.type !== "executed") {
        this.errorLog("Transaction failed:", result.execution_info);
        if (result.execution_info.status.type === "moveabort") {
          this.errorLog("Move abort code:", result.execution_info.status.abort_code);
          this.errorLog("Move abort location:", result.execution_info.status.location);
        }
        return false;
      }
      this.debugLog("Service added successfully");
      return true;
    } catch (error) {
      this.errorLog(`Error adding service to ${did}:`, error);
      return false;
    }
  }
  /**
   * Add a service with properties to a DID document on Rooch blockchain
   */
  async addServiceWithProperties(did, service, options) {
    try {
      this.validateDIDMethod(did);
      const signer = options?.signer;
      if (!signer) {
        throw createSignerError(
          "SIGNER_NOT_AVAILABLE" /* SIGNER_NOT_AVAILABLE */,
          "No signer provided for addServiceWithProperties operation",
          { operation: "addServiceWithProperties", did }
        );
      }
      const didAccountSigner = await this.convertSigner(signer, options?.keyId);
      const currentDoc = await this.resolve(did);
      if (!currentDoc) {
        throw createVDRError("DID_NOT_FOUND" /* DID_NOT_FOUND */, `DID document ${did} not found`, {
          did
        });
      }
      const signerAddress = didAccountSigner.getRoochAddress ? didAccountSigner.getRoochAddress().toBech32Address() : null;
      if (signerAddress && !this.hasPermissionForOperation(currentDoc, signerAddress, "capabilityInvocation")) {
        this.errorLog(`Signer does not have capabilityInvocation permission for ${did}`);
        return false;
      }
      const properties = service.properties || {};
      const propertyKeys = Object.keys(properties);
      const propertyValues = Object.values(properties);
      const transaction = this.createTransaction();
      transaction.callFunction({
        target: `${this.didContractAddress}::add_service_with_properties_entry`,
        args: [
          Args.string(extractFragmentFromId(service.id)),
          Args.string(service.type),
          Args.string(service.serviceEndpoint),
          Args.vec("string", propertyKeys),
          Args.vec("string", propertyValues)
        ],
        maxGas: options?.advanced?.maxGas || 1e8
      });
      const result = await this.client.signAndExecuteTransaction({
        transaction,
        signer: didAccountSigner,
        option: { withOutput: true }
      });
      return result.execution_info.status.type === "executed";
    } catch (error) {
      this.errorLog(`Error adding service with properties to ${did}:`, error);
      return false;
    }
  }
  /**
   * Remove a service from a DID document on Rooch blockchain
   */
  async removeService(did, id, options) {
    try {
      this.validateDIDMethod(did);
      const signer = options?.signer;
      if (!signer) {
        throw createSignerError(
          "SIGNER_NOT_AVAILABLE" /* SIGNER_NOT_AVAILABLE */,
          "No signer provided for removeService operation",
          { operation: "removeService", did, id }
        );
      }
      const didAccountSigner = await this.convertSigner(signer, options?.keyId);
      const currentDoc = await this.resolve(did);
      if (!currentDoc) {
        throw createVDRError("DID_NOT_FOUND" /* DID_NOT_FOUND */, `DID document ${did} not found`, {
          did
        });
      }
      const signerAddress = didAccountSigner.getRoochAddress().toBech32Address();
      if (signerAddress && !this.hasPermissionForOperation(currentDoc, signerAddress, "capabilityInvocation")) {
        this.errorLog(`Signer does not have capabilityInvocation permission for ${did}`);
        return false;
      }
      const transaction = this.createTransaction();
      transaction.callFunction({
        target: `${this.didContractAddress}::remove_service_entry`,
        args: [Args.string(extractFragmentFromId(id))],
        maxGas: options?.advanced?.maxGas || 1e8
      });
      const result = await this.client.signAndExecuteTransaction({
        transaction,
        signer: didAccountSigner,
        option: { withOutput: true }
      });
      return result.execution_info.status.type === "executed";
    } catch (error) {
      this.errorLog(`Error removing service from ${did}:`, error);
      return false;
    }
  }
  /**
   * Update verification relationships for a verification method on Rooch blockchain
   */
  async updateRelationships(did, id, add, remove, options) {
    try {
      this.validateDIDMethod(did);
      const signer = options?.signer;
      if (!signer) {
        throw createSignerError(
          "SIGNER_NOT_AVAILABLE" /* SIGNER_NOT_AVAILABLE */,
          "No signer provided for updateRelationships operation",
          { operation: "updateRelationships", did, id }
        );
      }
      const didAccountSigner = await this.convertSigner(signer, options?.keyId);
      const currentDoc = await this.resolve(did);
      if (!currentDoc) {
        throw createVDRError("DID_NOT_FOUND" /* DID_NOT_FOUND */, `DID document ${did} not found`, {
          did
        });
      }
      const signerAddress = didAccountSigner.getRoochAddress().toBech32Address();
      if (signerAddress && !this.hasPermissionForOperation(currentDoc, signerAddress, "capabilityDelegation")) {
        this.errorLog(`Signer does not have capabilityDelegation permission for ${did}`);
        return false;
      }
      const fragment = extractFragmentFromId(id);
      for (const relationship of add) {
        const relationshipValue = this.convertVerificationRelationship(relationship);
        const transaction = this.createTransaction();
        transaction.callFunction({
          target: `${this.didContractAddress}::add_to_verification_relationship_entry`,
          args: [Args.string(fragment), Args.u8(relationshipValue)],
          maxGas: options?.advanced?.maxGas || 1e8
        });
        const result = await this.client.signAndExecuteTransaction({
          transaction,
          signer: didAccountSigner,
          option: { withOutput: true }
        });
        if (result.execution_info.status.type !== "executed") {
          return false;
        }
      }
      for (const relationship of remove) {
        const relationshipValue = this.convertVerificationRelationship(relationship);
        const transaction = this.createTransaction();
        transaction.callFunction({
          target: `${this.didContractAddress}::remove_from_verification_relationship_entry`,
          args: [Args.string(fragment), Args.u8(relationshipValue)],
          maxGas: options?.advanced?.maxGas || 1e8
        });
        const result = await this.client.signAndExecuteTransaction({
          transaction,
          signer: didAccountSigner,
          option: { withOutput: true }
        });
        if (result.execution_info.status.type !== "executed") {
          return false;
        }
      }
      return true;
    } catch (error) {
      this.errorLog(`Error updating relationships for ${did}:`, error);
      return false;
    }
  }
  /**
   * Create a new Rooch transaction instance
   */
  createTransaction() {
    return new Transaction2();
  }
  /**
   * Convert verification relationships to u8 values based on did.move constants
   */
  convertVerificationRelationships(relationships) {
    return relationships.map((rel) => this.convertVerificationRelationship(rel));
  }
  /**
   * Convert a single verification relationship to u8 value
   */
  convertVerificationRelationship(relationship) {
    switch (relationship) {
      case "authentication":
        return 0;
      // VERIFICATION_RELATIONSHIP_AUTHENTICATION
      case "assertionMethod":
        return 1;
      // VERIFICATION_RELATIONSHIP_ASSERTION_METHOD
      case "capabilityInvocation":
        return 2;
      // VERIFICATION_RELATIONSHIP_CAPABILITY_INVOCATION
      case "capabilityDelegation":
        return 3;
      // VERIFICATION_RELATIONSHIP_CAPABILITY_DELEGATION
      case "keyAgreement":
        return 4;
      // VERIFICATION_RELATIONSHIP_KEY_AGREEMENT
      default:
        throw createValidationError(
          "INVALID_PARAMETER" /* INVALID_PARAMETER */,
          `Unknown verification relationship: ${relationship}`,
          {
            relationship,
            validRelationships: [
              "authentication",
              "assertionMethod",
              "keyAgreement",
              "capabilityInvocation",
              "capabilityDelegation"
            ]
          }
        );
    }
  }
  /**
   * Check if a signer has permission to perform an operation on a DID
   */
  hasPermissionForOperation(didDocument, signerAddress, requiredRelationship) {
    try {
      this.debugLog(`Checking permission for signer ${signerAddress} on DID ${didDocument.id}`);
      this.debugLog(`Required relationship: ${requiredRelationship}`);
      this.debugLog(`DID controllers:`, didDocument.controller);
      const signerDIDHex = `did:rooch:${signerAddress}`;
      this.debugLog(`Signer DID (hex):`, signerDIDHex);
      const didMatch = didDocument.id.match(/did:rooch:(.+)$/);
      const didAddress = didMatch ? didMatch[1] : null;
      this.debugLog(`DID account address:`, didAddress);
      this.debugLog(`Signer address:`, signerAddress);
      if (didAddress && signerAddress.toLowerCase() === didAddress.toLowerCase()) {
        this.debugLog(`Permission granted: Signer is the DID account itself`);
        return true;
      }
      this.errorLog(`Permission issue: Signer is not the DID account`);
      this.debugLog(`In Rooch DID system:`);
      this.debugLog(`   - DID account address: ${didAddress}`);
      this.debugLog(`   - Signer address: ${signerAddress}`);
      this.debugLog(`   - Operations must be signed by the DID account, not the controller`);
      this.debugLog(`   - DID accounts can only sign via SessionKey or similar mechanism`);
      if (Array.isArray(didDocument.controller)) {
        for (const controller of didDocument.controller) {
          this.debugLog(`Checking controller:`, controller);
          if (controller === signerDIDHex) {
            this.debugLog(`Signer is a controller (hex format) but may fail at contract level`);
            return true;
          }
          if (controller.includes("rooch1")) {
            this.debugLog(
              `Signer appears to be a controller (bech32 format) but may fail at contract level`
            );
            return true;
          }
          const controllerMatch = controller.match(/did:rooch:(.+)$/);
          if (controllerMatch) {
            const controllerAddress = controllerMatch[1];
            if (controllerAddress === signerAddress || controllerAddress.toLowerCase() === signerAddress.toLowerCase()) {
              this.debugLog(`Address match found but may fail at contract level`);
              return true;
            }
          }
        }
      }
      if (!didDocument.verificationMethod) {
        this.debugLog(`No verification methods found`);
        return false;
      }
      for (const vm of didDocument.verificationMethod) {
        this.debugLog(`Checking verification method: ${vm.id}, controller: ${vm.controller}`);
        const isControlledBySigner = vm.controller === signerDIDHex || vm.controller === didDocument.id || Array.isArray(didDocument.controller) && didDocument.controller.includes(signerDIDHex);
        if (isControlledBySigner) {
          this.debugLog(`VM ${vm.id} is controlled by signer, checking relationships...`);
          const relationshipArray = didDocument[requiredRelationship];
          if (relationshipArray) {
            this.debugLog(`Relationship array for ${requiredRelationship}:`, relationshipArray);
            const hasRelationship = relationshipArray.some((item) => {
              if (typeof item === "string") {
                return item === vm.id;
              } else if (typeof item === "object" && item.id) {
                return item.id === vm.id;
              }
              return false;
            });
            if (hasRelationship) {
              this.debugLog(`VM has required relationship but signer may not be DID account`);
              return true;
            }
          }
        }
      }
      this.errorLog(`Permission denied: No matching controller or VM relationship found`);
      return false;
    } catch (error) {
      this.errorLog("Error checking permission:", error);
      return false;
    }
  }
  /**
   * Parse DIDCreatedEvent using BCS schema and return the DID address
   */
  parseDIDCreatedEventAndGetDID(event) {
    try {
      const eventData = parseDIDCreatedEvent(event.event_data);
      return eventData.did;
    } catch (error) {
      this.errorLog("BCS parsing failed:", error);
      throw error;
    }
  }
  /**
   * Get the last created DID address from the most recent store operation
   */
  getLastCreatedDIDAddress() {
    return this.lastCreatedDIDAddress;
  }
  /**
   * Create a RoochVDR instance with default configuration
   */
  static createDefault(network = "test", rpcUrl = void 0) {
    return new _RoochVDR({
      rpcUrl: rpcUrl || _RoochVDR.getRoochNodeUrl(network),
      network
    });
  }
  /**
   * Get network-specific RPC URL
   */
  static getRoochNodeUrl(network) {
    const networkMap = {
      local: "localnet",
      dev: "devnet",
      test: "testnet",
      main: "mainnet"
    };
    const roochNetwork = networkMap[network] || network;
    return sdkGetRoochNodeUrl(roochNetwork);
  }
};

// src/vdr/types.ts
var AUTH_PROVIDERS = {
  WEBAUTHN: "webauthn",
  BITCOIN: "bitcoin",
  ETHEREUM: "ethereum"
};

// src/vdr/index.ts
function createVDR(method, options) {
  switch (method.toLowerCase()) {
    case "key":
      return new KeyVDR();
    case "rooch":
      return new RoochVDR(options);
    // Add additional DID methods as needed
    default:
      throw createVDRError(
        "VDR_NOT_AVAILABLE" /* VDR_NOT_AVAILABLE */,
        `No built-in VDR implementation available for method '${method}'`,
        { method, availableMethods: ["key", "rooch"] }
      );
  }
}
function createDefaultVDRs(options) {
  return [new KeyVDR(), new RoochVDR(options?.rooch || {})];
}
function initRoochVDR(network = "test", rpcUrl = void 0, registry = VDRRegistry.getInstance()) {
  const existing = registry.getVDR("rooch");
  if (existing) {
    return existing;
  }
  const vdr = RoochVDR.createDefault(network, rpcUrl);
  registry.registerVDR(vdr);
  return vdr;
}

// src/keys/KeyStore.ts
var MemoryKeyStore = class {
  constructor() {
    this.map = /* @__PURE__ */ new Map();
  }
  /**
   * List all available key IDs in this store
   */
  async listKeyIds() {
    return Array.from(this.map.keys());
  }
  /**
   * Load a key by its ID
   * @param keyId Key ID to load
   */
  async load(keyId) {
    if (!keyId) {
      const firstKey = Array.from(this.map.values())[0];
      return firstKey || null;
    }
    return this.map.get(keyId) || null;
  }
  /**
   * Save a key to in-memory storage
   * @param key The key to save
   */
  async save(key) {
    this.map.set(key.keyId, key);
  }
  /**
   * Clear a specific key or all keys
   * @param keyId Optional key ID to clear (if omitted, clears all keys)
   */
  async clear(keyId) {
    if (keyId) {
      this.map.delete(keyId);
    } else {
      this.map.clear();
    }
  }
  // No sign implementation for MemoryKeyStore; relies on plaintext extraction.
};

// src/keys/StoredKeyCodec.ts
var StoredKeyCodec = class {
  /**
   * Encode a StoredKey to a base58btc multibase string
   * @param key The StoredKey to encode
   * @returns base58btc encoded string with 'z' prefix
   */
  static encode(key) {
    const json = JSON.stringify(key);
    const jsonBytes = stringToBytes(json);
    return MultibaseCodec.encodeBase58btc(jsonBytes);
  }
  /**
   * Decode a multibase string to a StoredKey with automatic key consistency validation
   * @param serialized The multibase encoded string
   * @returns The decoded and validated StoredKey
   * @throws Error if decoding fails or key validation fails
   */
  static async decode(serialized) {
    const jsonBytes = MultibaseCodec.decode(serialized);
    const jsonStr = bytesToString(jsonBytes);
    const key = JSON.parse(jsonStr);
    const isValid = await this.validateKeyConsistency(key);
    if (!isValid) {
      throw createValidationError(
        "KEY_VALIDATION_FAILED" /* KEY_VALIDATION_FAILED */,
        "StoredKey validation failed: private and public keys are inconsistent",
        { keyId: key.keyId, keyType: key.keyType }
      );
    }
    return key;
  }
  /**
   * Validate the consistency between private key and public key in StoredKey
   * @param key The StoredKey to validate
   * @returns true if keys are consistent or validation can be skipped, false otherwise
   */
  static async validateKeyConsistency(key) {
    if (!key.privateKeyMultibase || !key.publicKeyMultibase || key.privateKeyMultibase.trim() === "" || key.publicKeyMultibase.trim() === "") {
      return true;
    }
    try {
      const privateKeyBytes = MultibaseCodec.decode(key.privateKeyMultibase);
      const publicKeyBytes = MultibaseCodec.decode(key.publicKeyMultibase);
      return await CryptoUtils.validateKeyPairConsistency(
        privateKeyBytes,
        publicKeyBytes,
        key.keyType
      );
    } catch (error) {
      console.warn("Key consistency validation failed:", error);
      return false;
    }
  }
};

// src/keys/KeyManager.ts
import { decodeRoochSercetKey } from "@roochnetwork/rooch-sdk";
var KeyManager = class _KeyManager {
  /**
   * Create a new KeyManager
   * @param options Configuration options
   */
  constructor(options) {
    this.store = options?.store || new MemoryKeyStore();
    this.did = options?.did;
    this.defaultKeyType = options?.defaultKeyType || "Ed25519VerificationKey2020" /* ED25519 */;
  }
  /**
   * Generate a new key and store it
   * @param fragment Optional fragment for the key ID (e.g., 'key-1')
   * @param keyType Optional key type (defaults to the manager's defaultKeyType)
   * @returns The stored key information
   */
  async generateKey(fragment, keyType) {
    if (!this.did) {
      throw createKeyManagementError(
        "DID_NOT_SET" /* DID_NOT_SET */,
        "DID must be set before generating keys",
        { operation: "generateKey" }
      );
    }
    const type = keyType || this.defaultKeyType;
    const keyPair = await CryptoUtils.generateKeyPair(type);
    const keyFragment = fragment || `key-${Date.now()}`;
    const keyId = `${this.did}#${keyFragment}`;
    const publicKeyEncoded = MultibaseCodec.encodeBase58btc(keyPair.publicKey);
    const privateKeyEncoded = MultibaseCodec.encodeBase58btc(keyPair.privateKey);
    const storedKey = {
      keyId,
      keyType: type,
      publicKeyMultibase: publicKeyEncoded,
      privateKeyMultibase: privateKeyEncoded
    };
    await this.store.save(storedKey);
    return storedKey;
  }
  /**
   * Import an existing key into the store
   * @param key The key to import
   */
  async importKey(key) {
    const didFromKey = getDidWithoutFragment(key.keyId);
    if (this.did && didFromKey !== this.did) {
      throw createKeyManagementError(
        "KEY_DID_MISMATCH" /* KEY_DID_MISMATCH */,
        `Key belongs to a different DID: ${didFromKey}`,
        { expectedDid: this.did, actualDid: didFromKey, keyId: key.keyId }
      );
    }
    if (!this.did) {
      this.did = didFromKey;
    }
    await this.store.save(key);
  }
  /**
   * Delete a key from the store
   * @param keyId ID of the key to delete
   */
  async deleteKey(keyId) {
    await this.store.clear(keyId);
  }
  /**
   * Clear all keys from the store
   */
  async clear() {
    await this.store.clear();
  }
  /**
   * List all available key IDs
   */
  async listKeyIds() {
    return this.store.listKeyIds();
  }
  /**
   * Get a stored key by its ID
   * @param keyId ID of the key to retrieve
   * @returns The stored key or null if not found
   */
  async getStoredKey(keyId) {
    return this.store.load(keyId);
  }
  /**
   * Set the DID for this manager
   * @param did The DID to set
   */
  setDid(did) {
    this.did = did;
  }
  /**
   * Get the DID
   * @returns The DID
   */
  async getDid() {
    if (this.did) return this.did;
    const keyIds = await this.listKeyIds();
    if (keyIds.length > 0) {
      this.did = getDidWithoutFragment(keyIds[0]);
      return this.did;
    }
    throw createKeyManagementError(
      "DID_NOT_SET" /* DID_NOT_SET */,
      "DID not initialised. Call setDid() or import a key first.",
      { operation: "getDidAccountSigner" }
    );
  }
  /**
   * Sign data with a specific key
   * @param data Data to sign
   * @param keyId ID of the key to use
   * @returns The signature
   */
  async signWithKeyId(data, keyId) {
    return signWithKeyStore(this.store, data, keyId);
  }
  /**
   * Check if a key is available for signing
   * @param keyId ID of the key to check
   * @returns True if the key exists and can be used for signing
   */
  async canSignWithKeyId(keyId) {
    return canSignWithKeyStore(this.store, keyId);
  }
  /**
   * Get information about a specific key
   * @param keyId ID of the key to get information about
   * @returns Key information or undefined if not found
   */
  async getKeyInfo(keyId) {
    return getKeyInfoFromKeyStore(this.store, keyId);
  }
  /**
   * Find the first key with a specific key type
   * @param keyType The key type to search for
   * @returns The key ID or undefined if not found
   */
  async findKeyByType(keyType) {
    const keyIds = await this.listKeyIds();
    for (const keyId of keyIds) {
      const key = await this.getStoredKey(keyId);
      if (key && key.keyType === keyType) {
        return keyId;
      }
    }
    return void 0;
  }
  /**
   * Get the underlying key store
   * @returns The key store
   */
  getStore() {
    return this.store;
  }
  /** Create an empty KeyManager instance and bind DID */
  static createEmpty(did, store = new MemoryKeyStore()) {
    const km = new _KeyManager({ store });
    km.setDid(did);
    return km;
  }
  /** Create KeyManager and immediately generate a key */
  static async createWithNewKey(did, fragment = `key-${Date.now()}`, type = "Ed25519VerificationKey2020" /* ED25519 */, store = new MemoryKeyStore()) {
    const km = _KeyManager.createEmpty(did, store);
    const stored = await km.generateKey(fragment, type);
    return { keyManager: km, keyId: stored.keyId };
  }
  /** Create KeyManager and import existing key pair */
  static async createWithKeyPair(did, keyPair, fragment = "account-key", type = "Ed25519VerificationKey2020" /* ED25519 */, store = new MemoryKeyStore()) {
    const km = _KeyManager.createEmpty(did, store);
    const keyId = await km.importKeyPair(fragment, keyPair, type);
    return { keyManager: km, keyId };
  }
  /** Utility: generate did:key + master key */
  static async createWithDidKey() {
    const { publicKey, privateKey } = await CryptoUtils.generateKeyPair("Ed25519VerificationKey2020" /* ED25519 */);
    const publicKeyMultibase = KeyMultibaseCodec.encodeWithType(publicKey, "Ed25519VerificationKey2020" /* ED25519 */);
    const didKey = `did:key:${publicKeyMultibase}`;
    const km = _KeyManager.createEmpty(didKey);
    const keyId = await km.importKeyPair("account-key", { privateKey, publicKey }, "Ed25519VerificationKey2020" /* ED25519 */);
    return { keyManager: km, keyId, did: didKey };
  }
  /** Instance helper: import raw key pair (Uint8Array) */
  async importKeyPair(fragment, keyPair, type = "Ed25519VerificationKey2020" /* ED25519 */) {
    const did = await this.getDid();
    const keyId = `${did}#${fragment}`;
    if (await this.getKeyInfo(keyId)) {
      throw createKeyManagementError(
        "KEY_ALREADY_EXISTS" /* KEY_ALREADY_EXISTS */,
        `Key ID ${keyId} already exists in store`,
        { keyId }
      );
    }
    const isConsistent = await CryptoUtils.validateKeyPairConsistency(
      keyPair.privateKey,
      keyPair.publicKey,
      type
    );
    if (!isConsistent) {
      throw createValidationError(
        "KEY_VALIDATION_FAILED" /* KEY_VALIDATION_FAILED */,
        "Key pair validation failed: private and public keys are inconsistent",
        { keyId, keyType: type }
      );
    }
    await this.importKey({
      keyId,
      keyType: type,
      publicKeyMultibase: MultibaseCodec.encodeBase58btc(keyPair.publicKey),
      privateKeyMultibase: MultibaseCodec.encodeBase58btc(keyPair.privateKey)
    });
    return keyId;
  }
  /** Instance helper: import Rooch Keypair */
  async importRoochKeyPair(fragment, roochKeyPair) {
    const { secretKey, schema } = decodeRoochSercetKey(roochKeyPair.getSecretKey());
    const keyType = roochSignatureSchemeToKeyType(schema);
    return this.importKeyPair(
      fragment,
      {
        privateKey: secretKey,
        publicKey: roochKeyPair.getPublicKey().toBytes()
      },
      keyType
    );
  }
  /**
   * Export a stored key to a base58btc encoded string
   * @param keyId The ID of the key to export
   * @returns base58btc encoded string representation of the StoredKey
   */
  async exportKeyToString(keyId) {
    const key = await this.getStoredKey(keyId);
    if (!key) {
      throw createKeyManagementError("KEY_NOT_FOUND" /* KEY_NOT_FOUND */, `Key ${keyId} not found`, {
        keyId
      });
    }
    return StoredKeyCodec.encode(key);
  }
  /**
   * Import a StoredKey from a base58btc encoded string into the current KeyManager
   * @param serialized The base58btc encoded string representation of a StoredKey
   * @returns The imported StoredKey
   */
  async importKeyFromString(serialized) {
    const key = await StoredKeyCodec.decode(serialized);
    await this.importKey(key);
    return key;
  }
  /**
   * Create a new KeyManager from a serialized StoredKey string
   * @param serialized The base58btc encoded string representation of a StoredKey
   * @param store Optional key store (defaults to MemoryKeyStore)
   * @returns A new KeyManager instance with the imported key
   */
  static async fromSerializedKey(serialized, store = new MemoryKeyStore()) {
    const key = await StoredKeyCodec.decode(serialized);
    const km = _KeyManager.createEmpty(getDidWithoutFragment(key.keyId), store);
    await km.importKey(key);
    return km;
  }
};

// src/IdentityEnv.ts
var IdentityEnv = class {
  constructor(registry, keyManager) {
    this.registry = registry;
    this.keyManager = keyManager;
  }
  /**
   * Load an existing DID and return a ready IdentityKit instance
   */
  async loadDid(did, signer) {
    const s = signer || this.keyManager;
    if (!signer) {
      try {
        this.keyManager.setDid(did);
      } catch (_) {
      }
    }
    return IdentityKit.fromExistingDID(did, s);
  }
  /**
   * Load from a known DID Document
   */
  async fromDocument(doc, signer) {
    const s = signer || this.keyManager;
    if (!signer) {
      this.keyManager.setDid(getDidWithoutFragment(doc.id));
    }
    return IdentityKit.fromDIDDocument(doc, s);
  }
  /**
   * Create a new DID via the underlying VDR
   */
  async createDid(method, request, signer, options) {
    const s = signer || this.keyManager;
    return IdentityKit.createNewDID(method, request, s, options);
  }
};
var IdentityEnvBuilder = class {
  constructor() {
    this.vdrConfigs = [];
  }
  /** Register (or ensure) a VDR for given DID method */
  useVDR(method, options) {
    this.vdrConfigs.push({ method, options });
    return this;
  }
  /** Provide a custom KeyStore implementation */
  useKeyStore(store) {
    this.keyStore = store;
    return this;
  }
  /** Provide a pre-built KeyManager (advanced) */
  useKeyManager(manager) {
    this.keyManager = manager;
    return this;
  }
  /** Finalise and return the environment */
  async init() {
    const registry = VDRRegistry.getInstance();
    for (const { method, options } of this.vdrConfigs) {
      if (!registry.getVDR(method)) {
        const vdr = createVDR(method, options);
        registry.registerVDR(vdr);
      }
    }
    let km;
    if (this.keyManager) {
      km = this.keyManager;
    } else {
      const store = this.keyStore || new MemoryKeyStore();
      km = new KeyManager({ store });
    }
    return new IdentityEnv(registry, km);
  }
};
async function bootstrapIdentityEnv(opts = {}) {
  const builder = new IdentityEnvBuilder();
  const method = opts.method || "rooch";
  builder.useVDR(method, opts.vdrOptions);
  if (opts.keyStore) builder.useKeyStore(opts.keyStore);
  return builder.init();
}

// src/IdentityKit.ts
var _IdentityKit = class _IdentityKit {
  // Private constructor, force use of factory methods
  constructor(didDocument, vdr, signer) {
    this.didDocument = didDocument;
    this.vdr = vdr;
    this.signer = signer;
  }
  // Factory methods
  /**
   * Create an instance from an existing DID (for managing existing DIDs)
   */
  static async fromExistingDID(did, signer) {
    const registry = VDRRegistry.getInstance();
    const method = extractMethod(did);
    const vdr = registry.getVDR(method);
    if (!vdr) {
      throw createVDRError(
        "VDR_NOT_AVAILABLE" /* VDR_NOT_AVAILABLE */,
        `No VDR available for DID method '${method}'`,
        { method, did }
      );
    }
    const didDocument = await registry.resolveDID(did, { forceRefresh: true });
    if (!didDocument) {
      throw createDIDError(
        "DID_RESOLUTION_FAILED" /* DID_RESOLUTION_FAILED */,
        `Failed to resolve DID: ${did}`,
        { did, method }
      );
    }
    return new _IdentityKit(didDocument, vdr, signer);
  }
  /**
   * Create an instance from a DID Document (for scenarios with known DID Document)
   */
  static fromDIDDocument(didDocument, signer) {
    const { method } = parseDid(didDocument.id);
    const vdr = VDRRegistry.getInstance().getVDR(method);
    if (!vdr) {
      throw createVDRError(
        "VDR_NOT_AVAILABLE" /* VDR_NOT_AVAILABLE */,
        `No VDR available for DID method '${method}'`,
        { method, did: didDocument.id }
      );
    }
    return new _IdentityKit(didDocument, vdr, signer);
  }
  /**
   * Create and publish a new DID
   */
  static async createNewDID(method, creationRequest, signer, options) {
    const registry = VDRRegistry.getInstance();
    const vdr = registry.getVDR(method);
    if (!vdr) {
      throw createVDRError(
        "VDR_NOT_AVAILABLE" /* VDR_NOT_AVAILABLE */,
        `No VDR available for DID method '${method}'`,
        { method }
      );
    }
    const result = await registry.createDID(method, creationRequest, options);
    if (!result.success || !result.didDocument) {
      throw createDIDError(
        "DID_CREATION_FAILED" /* DID_CREATION_FAILED */,
        `Failed to create DID: ${result.error || "Unknown error"}`,
        { method, creationRequest, result }
      );
    }
    return new _IdentityKit(result.didDocument, vdr, signer);
  }
  /**
   * Lightweight environment bootstrap – prepares VDR(s) & KeyManager without touching DID.
   * It is a thin wrapper around `bootstrapIdentityEnv()` so that callers can simply do:
   * ```ts
   * const env = await IdentityKit.bootstrap({ method: 'rooch' });
   * const kit = await env.loadDid(did);
   * ```
   */
  static async bootstrap(opts = {}) {
    return bootstrapIdentityEnv(opts);
  }
  // Verification Method Management
  /**
   * Find a key that has the specified verification relationship and is available for signing
   * @param relationship The required verification relationship
   * @returns The key ID if found, undefined otherwise
   */
  async findKeyWithRelationship(relationship) {
    return this.findKeysWithRelationship(relationship).then((keys) => keys[0]);
  }
  /**
   * Find all keys that have the specified verification relationship and are available for signing
   * @param relationship The required verification relationship
   * @returns Array of key IDs that match the criteria
   */
  async findKeysWithRelationship(relationship) {
    const availableKeyIds = await this.signer.listKeyIds();
    if (!availableKeyIds.length) {
      return [];
    }
    const relationships = this.didDocument[relationship];
    if (!relationships?.length) {
      return [];
    }
    return relationships.map((item) => typeof item === "string" ? item : item.id).filter((keyId) => availableKeyIds.includes(keyId));
  }
  async addVerificationMethod(keyInfo, relationships, options) {
    const signingKeyId = options?.keyId || await this.findKeyWithRelationship("capabilityDelegation");
    if (!signingKeyId) {
      throw createKeyManagementError(
        "KEY_PERMISSION_DENIED" /* KEY_PERMISSION_DENIED */,
        "No key with capabilityDelegation permission available",
        {
          did: this.didDocument.id,
          requiredRelationship: "capabilityDelegation",
          availableKeys: await this.signer.listKeyIds()
        }
      );
    }
    const keyIdFragment = keyInfo.idFragment || `key-${Date.now()}`;
    const keyId = `${this.didDocument.id}#${keyIdFragment}`;
    const verificationMethodEntry = {
      id: keyId,
      type: keyInfo.type,
      controller: keyInfo.controller || this.didDocument.id,
      publicKeyMultibase: keyInfo.publicKeyMaterial instanceof Uint8Array ? await MultibaseCodec.encodeBase58btc(keyInfo.publicKeyMaterial) : void 0,
      publicKeyJwk: !(keyInfo.publicKeyMaterial instanceof Uint8Array) ? keyInfo.publicKeyMaterial : void 0
    };
    const published = await this.vdr.addVerificationMethod(
      this.didDocument.id,
      verificationMethodEntry,
      relationships,
      {
        signer: this.signer,
        keyId: signingKeyId,
        scopes: options?.scopes
      }
    );
    if (!published) {
      throw createVDRError(
        "VDR_OPERATION_FAILED" /* VDR_OPERATION_FAILED */,
        `Failed to publish verification method ${keyId}`,
        {
          did: this.didDocument.id,
          keyId,
          relationships,
          verificationMethod: verificationMethodEntry
        }
      );
    }
    await this.updateLocalDIDDocument();
    return keyId;
  }
  async removeVerificationMethod(keyId, options) {
    const signingKeyId = options?.keyId || await this.findKeyWithRelationship("capabilityDelegation");
    if (!signingKeyId) {
      throw createKeyManagementError(
        "KEY_PERMISSION_DENIED" /* KEY_PERMISSION_DENIED */,
        "No key with capabilityDelegation permission available",
        {
          did: this.didDocument.id,
          requiredRelationship: "capabilityDelegation",
          targetKeyId: keyId,
          availableKeys: await this.signer.listKeyIds()
        }
      );
    }
    const published = await this.vdr.removeVerificationMethod(this.didDocument.id, keyId, {
      signer: this.signer
    });
    if (published) {
      if (this.didDocument.verificationMethod) {
        this.didDocument.verificationMethod = this.didDocument.verificationMethod.filter(
          (vm) => vm.id !== keyId
        );
      }
      const relationships = [
        "authentication",
        "assertionMethod",
        "keyAgreement",
        "capabilityInvocation",
        "capabilityDelegation"
      ];
      relationships.forEach((rel) => {
        if (this.didDocument[rel]) {
          this.didDocument[rel] = this.didDocument[rel].filter((item) => {
            if (typeof item === "string") return item !== keyId;
            if (typeof item === "object" && item.id) return item.id !== keyId;
            return true;
          });
        }
      });
      return true;
    }
    return false;
  }
  async updateVerificationMethodRelationships(keyId, addRelationships, removeRelationships, options) {
    const published = await this.vdr.updateRelationships(
      this.didDocument.id,
      keyId,
      addRelationships,
      removeRelationships,
      {
        signer: options.signer
      }
    );
    if (published) {
      addRelationships.forEach((rel) => {
        if (!this.didDocument[rel]) {
          this.didDocument[rel] = [];
        }
        const relationshipArray = this.didDocument[rel];
        if (!relationshipArray.some((item) => {
          return typeof item === "string" ? item === keyId : item.id === keyId;
        })) {
          relationshipArray.push(keyId);
        }
      });
      removeRelationships.forEach((rel) => {
        if (this.didDocument[rel]) {
          this.didDocument[rel] = this.didDocument[rel].filter((item) => {
            if (typeof item === "string") return item !== keyId;
            if (typeof item === "object" && item.id) return item.id !== keyId;
            return true;
          });
        }
      });
      return true;
    }
    return false;
  }
  // Service Management
  async addService(serviceInfo, options) {
    const signingKeyId = options?.keyId || await this.findKeyWithRelationship("capabilityInvocation");
    if (!signingKeyId) {
      throw createKeyManagementError(
        "KEY_PERMISSION_DENIED" /* KEY_PERMISSION_DENIED */,
        "No key with capabilityInvocation permission available",
        {
          did: this.didDocument.id,
          requiredRelationship: "capabilityInvocation",
          serviceInfo,
          availableKeys: await this.signer.listKeyIds()
        }
      );
    }
    const serviceId = `${this.didDocument.id}#${serviceInfo.idFragment}`;
    const serviceEntry = {
      id: serviceId,
      type: serviceInfo.type,
      serviceEndpoint: serviceInfo.serviceEndpoint,
      ...serviceInfo.additionalProperties || {}
    };
    const published = await this.vdr.addService(this.didDocument.id, serviceEntry, {
      signer: this.signer,
      keyId: signingKeyId
    });
    if (!published) {
      throw createVDRError(
        "VDR_OPERATION_FAILED" /* VDR_OPERATION_FAILED */,
        `Failed to publish service ${serviceId}`,
        {
          did: this.didDocument.id,
          serviceId,
          serviceInfo,
          serviceEntry
        }
      );
    }
    this.didDocument = await this.vdr.resolve(this.didDocument.id);
    _IdentityKit.logger.debug("After addService", this.didDocument);
    return serviceId;
  }
  async removeService(serviceId, options) {
    const signingKeyId = options?.keyId || await this.findKeyWithRelationship("capabilityInvocation");
    if (!signingKeyId) {
      throw createKeyManagementError(
        "KEY_PERMISSION_DENIED" /* KEY_PERMISSION_DENIED */,
        "No key with capabilityInvocation permission available",
        {
          did: this.didDocument.id,
          requiredRelationship: "capabilityInvocation",
          serviceId,
          availableKeys: await this.signer.listKeyIds()
        }
      );
    }
    const published = await this.vdr.removeService(this.didDocument.id, serviceId, {
      signer: this.signer,
      keyId: signingKeyId
    });
    if (published) {
      if (this.didDocument.service) {
        this.didDocument.service = this.didDocument.service.filter((s) => s.id !== serviceId);
      }
      return true;
    }
    return false;
  }
  // Document Access
  getDIDDocument() {
    return this.didDocument;
  }
  // Service Discovery
  findServiceByType(serviceType) {
    return this.didDocument.service?.find((s) => s.type === serviceType);
  }
  findVerificationMethodsByRelationship(relationship) {
    const relationships = this.didDocument[relationship];
    if (!relationships?.length) {
      return [];
    }
    return relationships.map((item) => typeof item === "string" ? item : item.id).map(
      (id) => this.didDocument.verificationMethod?.find((vm) => vm.id === id)
    );
  }
  // State Checks
  async canSignWithKey(keyId) {
    return this.signer.canSignWithKeyId(keyId);
  }
  async updateLocalDIDDocument() {
    this.didDocument = await this.vdr.resolve(this.didDocument.id);
    _IdentityKit.logger.debug("After updateLocalDIDDocument", this.didDocument);
  }
  getSigner() {
    return this.signer;
  }
  /**
   * Get all key IDs that are both present in DID document and available via Signer,
   * grouped by verification relationship.
   */
  async getAvailableKeyIds() {
    const relationships = [
      "authentication",
      "assertionMethod",
      "keyAgreement",
      "capabilityInvocation",
      "capabilityDelegation"
    ];
    const availableFromSigner = await this.signer.listKeyIds();
    const result = {};
    for (const rel of relationships) {
      const relArray = this.didDocument[rel];
      if (!relArray?.length) continue;
      const ids = relArray.map((item) => typeof item === "string" ? item : item.id).filter((id) => availableFromSigner.includes(id));
      if (ids.length) result[rel] = ids;
    }
    return result;
  }
};
// Logger instance for this class
_IdentityKit.logger = DebugLogger.get("IdentityKit");
var IdentityKit = _IdentityKit;

// src/CadopIdentityKit.ts
var CadopServiceType = /* @__PURE__ */ ((CadopServiceType2) => {
  CadopServiceType2["CUSTODIAN"] = "CadopCustodianService";
  CadopServiceType2["IDP"] = "CadopIdPService";
  CadopServiceType2["WEB2_PROOF"] = "CadopWeb2ProofService";
  return CadopServiceType2;
})(CadopServiceType || {});
var _CadopIdentityKit = class _CadopIdentityKit {
  constructor(nuwaKit) {
    this.nuwaKit = nuwaKit;
  }
  extractCustodianInfo() {
    const custodianServices = this.findServicesByType("CadopCustodianService" /* CUSTODIAN */);
    if (custodianServices.length > 0) {
      const custodianService = custodianServices[0];
      const logger3 = DebugLogger.get("CadopIdentityKit");
      logger3.debug("extractCustodianInfo", custodianService);
      return custodianService;
    }
    throw createDIDError(
      "DID_SERVICE_NOT_FOUND" /* DID_SERVICE_NOT_FOUND */,
      "Custodian service not found in service document",
      { serviceDocument: this.nuwaKit.getDIDDocument(), serviceType: "CadopCustodianService" /* CUSTODIAN */ }
    );
  }
  /**
   * Initialize a CadopIdentityKit instance from an existing CADOP service DID
   */
  static async fromServiceDID(serviceDid, signer) {
    const nuwaKit = await IdentityKit.fromExistingDID(serviceDid, signer);
    return new _CadopIdentityKit(nuwaKit);
  }
  /**
   * Create a new DID via CADOP protocol
   */
  async createDID(method, userDid, options) {
    const custodianInfo = this.extractCustodianInfo();
    const authenticationMethods = this.nuwaKit.findVerificationMethodsByRelationship("authentication");
    if (authenticationMethods.length === 0) {
      throw createDIDError(
        "DID_VERIFICATION_METHOD_NOT_FOUND" /* DID_VERIFICATION_METHOD_NOT_FOUND */,
        "No authentication method found in service document",
        { serviceDocument: this.nuwaKit.getDIDDocument(), relationship: "authentication" }
      );
    }
    const authenticationMethod = authenticationMethods[0];
    const { custodianPublicKey, custodianServiceVMType } = custodianInfo.custodianPublicKey && custodianInfo.custodianServiceVMType ? {
      custodianPublicKey: custodianInfo.custodianPublicKey,
      custodianServiceVMType: custodianInfo.custodianServiceVMType
    } : {
      custodianPublicKey: authenticationMethod.publicKeyMultibase,
      custodianServiceVMType: authenticationMethod.type
    };
    if (!custodianPublicKey || !custodianServiceVMType) {
      throw createValidationError(
        "VALIDATION_FAILED" /* VALIDATION_FAILED */,
        "Custodian service configuration not found in service document",
        { custodianPublicKey, custodianServiceVMType }
      );
    }
    const creationRequest = {
      userDidKey: userDid,
      custodianServicePublicKey: custodianPublicKey,
      custodianServiceVMType,
      customScopes: options?.customScopes
    };
    return VDRRegistry.getInstance().createDIDViaCADOP(method, creationRequest, {
      signer: this.nuwaKit.getSigner(),
      ...options
    });
  }
  /**
   * Create a new DID via CADOP protocol with controller
   * Supports did:key (backward compatible), did:bitcoin, and other controller types
   */
  async createDIDWithController(method, controllerDid, options) {
    const logger3 = DebugLogger.get("CadopIdentityKit");
    logger3.debug("createDIDWithController called", { method, controllerDid, options });
    const custodianInfo = this.extractCustodianInfo();
    const authenticationMethods = this.nuwaKit.findVerificationMethodsByRelationship("authentication");
    if (authenticationMethods.length === 0) {
      throw createDIDError(
        "DID_VERIFICATION_METHOD_NOT_FOUND" /* DID_VERIFICATION_METHOD_NOT_FOUND */,
        "No authentication method found in service document",
        { serviceDocument: this.nuwaKit.getDIDDocument(), relationship: "authentication" }
      );
    }
    const authenticationMethod = authenticationMethods[0];
    const { custodianPublicKey, custodianServiceVMType } = custodianInfo.custodianPublicKey && custodianInfo.custodianServiceVMType ? {
      custodianPublicKey: custodianInfo.custodianPublicKey,
      custodianServiceVMType: custodianInfo.custodianServiceVMType
    } : {
      custodianPublicKey: authenticationMethod.publicKeyMultibase,
      custodianServiceVMType: authenticationMethod.type
    };
    if (!custodianPublicKey || !custodianServiceVMType) {
      throw createValidationError(
        "VALIDATION_FAILED" /* VALIDATION_FAILED */,
        "Custodian service configuration not found in service document",
        { custodianPublicKey, custodianServiceVMType }
      );
    }
    if (controllerDid.startsWith("did:key:") && !options?.controllerPublicKeyMultibase) {
      logger3.debug("Using backward compatible did:key path");
      const creationRequest2 = {
        userDidKey: controllerDid,
        custodianServicePublicKey: custodianPublicKey,
        custodianServiceVMType,
        customScopes: options?.customScopes
      };
      return VDRRegistry.getInstance().createDIDViaCADOP(method, creationRequest2, {
        signer: this.nuwaKit.getSigner(),
        ...options
      });
    }
    logger3.debug("Using controller-based CADOP path");
    const creationRequest = {
      controllerDid,
      controllerPublicKeyMultibase: options?.controllerPublicKeyMultibase,
      controllerVMType: options?.controllerVMType,
      custodianServicePublicKey: custodianPublicKey,
      custodianServiceVMType,
      customScopes: options?.customScopes
    };
    return VDRRegistry.getInstance().createDIDViaCADOPWithController(method, creationRequest, {
      signer: this.nuwaKit.getSigner(),
      ...options
    });
  }
  /**
   * Add a new CADOP service to the service DID document
   */
  async addService(service) {
    const serviceEndpoint = {
      id: `${this.nuwaKit.getDIDDocument().id}#${service.idFragment}`,
      type: service.type,
      serviceEndpoint: service.serviceEndpoint,
      ...service.additionalProperties || {}
    };
    if (!_CadopIdentityKit.validateService(serviceEndpoint, service.type)) {
      throw createValidationError(
        "VALIDATION_FAILED" /* VALIDATION_FAILED */,
        `Invalid CADOP service configuration for type: ${service.type}`,
        { service, serviceType: service.type }
      );
    }
    const result = await this.nuwaKit.addService(service);
    return result;
  }
  /**
   * Remove a CADOP service from the service DID document
   */
  async removeService(serviceId, options) {
    const result = await this.nuwaKit.removeService(serviceId, options);
    return result;
  }
  /**
   * Get the underlying IdentityKit instance
   */
  getNuwaIdentityKit() {
    return this.nuwaKit;
  }
  /**
   * Find all custodian services in the service document
   */
  findCustodianServices() {
    return this.findServicesByType("CadopCustodianService" /* CUSTODIAN */);
  }
  /**
   * Find all IdP services in the service document
   */
  findIdPServices() {
    return this.findServicesByType("CadopIdPService" /* IDP */);
  }
  /**
   * Find all Web2 proof services in the service document
   */
  findWeb2ProofServices() {
    return this.findServicesByType("CadopWeb2ProofService" /* WEB2_PROOF */);
  }
  /**
   * Find services by type in the service document
   */
  findServicesByType(type) {
    return (this.nuwaKit.getDIDDocument().service || []).filter((service) => service.type === type).filter((service) => _CadopIdentityKit.validateService(service, type));
  }
  /**
   * Validate a service against its type-specific validation rules
   */
  static validateService(service, type) {
    const rules = _CadopIdentityKit.SERVICE_VALIDATION_RULES[type];
    if (!rules) {
      return false;
    }
    const hasAllRequired = rules.requiredProperties.every(
      (prop) => prop in service && service[prop] !== void 0 && service[prop] !== null
    );
    if (!hasAllRequired) {
      return false;
    }
    const allowedProperties = /* @__PURE__ */ new Set([...rules.requiredProperties, ...rules.optionalProperties]);
    const hasUnknownProps = Object.keys(service).some((prop) => !allowedProperties.has(prop));
    if (hasUnknownProps) {
      return false;
    }
    if (rules.propertyValidators) {
      return Object.entries(rules.propertyValidators).every(([prop, validator]) => {
        if (prop in service) {
          return validator(service[prop]);
        }
        return true;
      });
    }
    return true;
  }
};
_CadopIdentityKit.SERVICE_VALIDATION_RULES = {
  ["CadopCustodianService" /* CUSTODIAN */]: {
    requiredProperties: ["id", "type", "serviceEndpoint"],
    optionalProperties: ["description", "fees", "custodianPublicKey", "custodianServiceVMType"],
    propertyValidators: {
      custodianPublicKey: (value) => typeof value === "string" && value.length > 0,
      custodianServiceVMType: (value) => typeof value === "string" && value.length > 0,
      fees: (value) => typeof value === "object" && value !== null
    }
  },
  ["CadopIdPService" /* IDP */]: {
    requiredProperties: ["id", "type", "serviceEndpoint"],
    optionalProperties: ["supportedCredentials", "description", "fees", "termsOfService"],
    propertyValidators: {
      supportedCredentials: (value) => typeof value === "string" || Array.isArray(value) && value.length > 0,
      fees: (value) => typeof value === "object" && value !== null,
      termsOfService: (value) => typeof value === "string" && value.length > 0
    }
  },
  ["CadopWeb2ProofService" /* WEB2_PROOF */]: {
    requiredProperties: ["id", "type", "serviceEndpoint"],
    optionalProperties: ["supportedPlatforms", "description", "fees"],
    propertyValidators: {
      supportedPlatforms: (value) => typeof value === "string" || Array.isArray(value) && value.length > 0,
      fees: (value) => typeof value === "object" && value !== null
    }
  }
};
var CadopIdentityKit = _CadopIdentityKit;

// src/auth/v1/index.ts
var v1_exports = {};
__export(v1_exports, {
  AuthErrorCode: () => AuthErrorCode,
  createSignature: () => createSignature,
  default: () => v1_default,
  toAuthorizationHeader: () => toAuthorizationHeader,
  verifyAuthHeader: () => verifyAuthHeader,
  verifySignature: () => verifySignature
});

// src/auth/v1/utils.ts
function canonicalize(obj) {
  const keys = Object.keys(obj).sort();
  return JSON.stringify(obj, keys);
}

// src/auth/v1/nonceStore.ts
var InMemoryNonceStore = class {
  constructor(options = {}) {
    this.capacity = options.capacity ?? 1e5;
    this.map = /* @__PURE__ */ new Map();
    const interval = options.sweepIntervalMs ?? 6e4;
    this.sweepInterval = setInterval(() => {
      this.sweep?.();
    }, interval);
    this.sweepInterval.unref?.();
  }
  compositeKey(signerDid, domainSeparator, nonce) {
    return `${signerDid}|${domainSeparator}|${nonce}`;
  }
  async tryStoreNonce(signerDid, domainSeparator, nonce, ttlSeconds) {
    const key = this.compositeKey(signerDid, domainSeparator, nonce);
    const now = Date.now();
    const expiresAt = now + ttlSeconds * 1e3;
    const existing = this.map.get(key);
    if (existing && existing > now) {
      return false;
    }
    if (this.map.size >= this.capacity) {
      const firstKey = this.map.keys().next().value;
      if (firstKey) this.map.delete(firstKey);
    }
    this.map.set(key, expiresAt);
    return true;
  }
  async sweep() {
    const now = Date.now();
    for (const [key, expires] of this.map.entries()) {
      if (expires <= now) {
        this.map.delete(key);
      }
    }
  }
};
var defaultNonceStore = new InMemoryNonceStore();

// src/auth/v1/index.ts
var AUTH_SCHEME = "DIDAuthV1";
var HEADER_PREFIX = `${AUTH_SCHEME} `;
var DEFAULT_DOMAIN_SEPARATOR = `${AUTH_SCHEME}:`;
var DEFAULT_MAX_CLOCK_SKEW = 300;
var AuthErrorCode = /* @__PURE__ */ ((AuthErrorCode2) => {
  AuthErrorCode2["INVALID_HEADER"] = "INVALID_HEADER";
  AuthErrorCode2["INVALID_BASE64"] = "INVALID_BASE64";
  AuthErrorCode2["INVALID_JSON"] = "INVALID_JSON";
  AuthErrorCode2["MISSING_SIGNATURE"] = "MISSING_SIGNATURE";
  AuthErrorCode2["TIMESTAMP_OUT_OF_WINDOW"] = "TIMESTAMP_OUT_OF_WINDOW";
  AuthErrorCode2["NONCE_REPLAYED"] = "NONCE_REPLAYED";
  AuthErrorCode2["SIGNATURE_VERIFICATION_FAILED"] = "SIGNATURE_VERIFICATION_FAILED";
  AuthErrorCode2["DID_DOCUMENT_NOT_FOUND"] = "DID_DOCUMENT_NOT_FOUND";
  AuthErrorCode2["VERIFICATION_METHOD_NOT_FOUND"] = "VERIFICATION_METHOD_NOT_FOUND";
  AuthErrorCode2["INVALID_PUBLIC_KEY"] = "INVALID_PUBLIC_KEY";
  AuthErrorCode2["DID_MISMATCH"] = "DID_MISMATCH";
  return AuthErrorCode2;
})(AuthErrorCode || {});
async function createSignature(payload, signer, keyId, opts = {}) {
  const signerDid = await signer.getDid();
  if (opts.didDocument) {
    if (opts.didDocument.id !== signerDid) {
      throw createAuthenticationError(
        "AUTH_DID_MISMATCH" /* AUTH_DID_MISMATCH */,
        `DID document ID ${opts.didDocument.id} does not match signer DID ${signerDid}`,
        { didDocumentId: opts.didDocument.id, signerDid }
      );
    }
    const verificationMethod = opts.didDocument.verificationMethod?.find((vm) => vm.id === keyId);
    if (!verificationMethod) {
      throw createAuthenticationError(
        "AUTH_VERIFICATION_METHOD_NOT_FOUND" /* AUTH_VERIFICATION_METHOD_NOT_FOUND */,
        `Verification method for keyId ${keyId} not found in DID document.`,
        { keyId, didDocument: opts.didDocument }
      );
    }
  }
  const signedData = {
    ...payload,
    nonce: opts.nonce ?? crypto.randomUUID(),
    timestamp: opts.timestamp ?? Math.floor(Date.now() / 1e3)
  };
  const canonicalData = canonicalize(signedData);
  const domainSeparator = opts.domainSeparator ?? DEFAULT_DOMAIN_SEPARATOR;
  const dataToSign = Bytes.stringToBytes(domainSeparator + canonicalData);
  const signatureValue = await signer.signWithKeyId(dataToSign, keyId);
  return {
    signed_data: signedData,
    signature: {
      signer_did: signerDid,
      key_id: keyId,
      value: signatureValue
    }
  };
}
function toAuthorizationHeader(obj) {
  const cloned = {
    signed_data: obj.signed_data,
    signature: {
      ...obj.signature,
      value: MultibaseCodec.encodeBase64url(obj.signature.value)
    }
  };
  const json = JSON.stringify(cloned);
  const b64url = MultibaseCodec.encodeBase64url(json);
  return `${HEADER_PREFIX}${b64url}`;
}
async function verifySignatureDetailed(signedObject, resolverOrDoc, opts = {}) {
  const { signed_data, signature } = signedObject;
  const attemptVerify = async (didDoc) => {
    const maxSkew = opts.maxClockSkew ?? DEFAULT_MAX_CLOCK_SKEW;
    const now = Math.floor(Date.now() / 1e3);
    if (Math.abs(now - signed_data.timestamp) > maxSkew) {
      return {
        ok: false,
        error: "Timestamp out of window",
        errorCode: "TIMESTAMP_OUT_OF_WINDOW" /* TIMESTAMP_OUT_OF_WINDOW */,
        signedObject
      };
    }
    if (didDoc.id !== signature.signer_did) {
      return {
        ok: false,
        error: "DID document ID does not match signer DID",
        errorCode: "DID_MISMATCH" /* DID_MISMATCH */,
        signedObject
      };
    }
    const verificationMethod = didDoc.verificationMethod?.find((vm) => vm.id === signature.key_id);
    if (!verificationMethod) {
      return {
        ok: false,
        error: "Verification method not found in DID document",
        errorCode: "VERIFICATION_METHOD_NOT_FOUND" /* VERIFICATION_METHOD_NOT_FOUND */,
        signedObject
      };
    }
    console.log("verificationMethod", verificationMethod);
    let publicKeyMaterial = null;
    if (verificationMethod.publicKeyJwk) {
      publicKeyMaterial = verificationMethod.publicKeyJwk;
    } else if (verificationMethod.publicKeyMultibase) {
      publicKeyMaterial = MultibaseCodec.decodeBase58btc(verificationMethod.publicKeyMultibase);
    }
    if (!publicKeyMaterial) {
      return {
        ok: false,
        error: "Invalid or missing public key material",
        errorCode: "INVALID_PUBLIC_KEY" /* INVALID_PUBLIC_KEY */,
        signedObject
      };
    }
    const canonicalData = canonicalize(signed_data);
    const dataToVerify = Bytes.stringToBytes(DEFAULT_DOMAIN_SEPARATOR + canonicalData);
    const isValid = await CryptoUtils.verify(
      dataToVerify,
      signature.value,
      publicKeyMaterial,
      verificationMethod.type
    );
    if (isValid) {
      return { ok: true, signedObject };
    } else {
      return {
        ok: false,
        error: "Signature verification failed",
        errorCode: "SIGNATURE_VERIFICATION_FAILED" /* SIGNATURE_VERIFICATION_FAILED */,
        signedObject
      };
    }
  };
  if (typeof resolverOrDoc.resolveDID === "function") {
    const resolver = resolverOrDoc;
    let doc = await resolver.resolveDID(signature.signer_did);
    if (doc) {
      const result = await attemptVerify(doc);
      if (result.ok) return result;
    }
    doc = await resolver.resolveDID(signature.signer_did, { forceRefresh: true });
    if (!doc) {
      return {
        ok: false,
        error: "DID document not found",
        errorCode: "DID_DOCUMENT_NOT_FOUND" /* DID_DOCUMENT_NOT_FOUND */,
        signedObject
      };
    }
    return attemptVerify(doc);
  } else {
    return attemptVerify(resolverOrDoc);
  }
}
async function verifySignature(signedObject, resolverOrDoc, opts = {}) {
  const result = await verifySignatureDetailed(signedObject, resolverOrDoc, opts);
  return result.ok;
}
async function verifyAuthHeader(header, resolver, opts = {}) {
  if (!header || !header.startsWith(HEADER_PREFIX)) {
    return {
      ok: false,
      error: "Unsupported or missing Authorization header",
      errorCode: "INVALID_HEADER" /* INVALID_HEADER */
    };
  }
  const b64url = header.substring(HEADER_PREFIX.length).trim();
  let payloadStr;
  try {
    payloadStr = Bytes.bytesToString(MultibaseCodec.decodeBase64url(b64url));
  } catch (e) {
    return {
      ok: false,
      error: "Invalid base64 credentials",
      errorCode: "INVALID_BASE64" /* INVALID_BASE64 */
    };
  }
  let parsed;
  try {
    parsed = JSON.parse(payloadStr);
  } catch (e) {
    return {
      ok: false,
      error: "Invalid JSON in credentials",
      errorCode: "INVALID_JSON" /* INVALID_JSON */
    };
  }
  if (!parsed?.signature?.value) {
    return {
      ok: false,
      error: "Missing signature value",
      errorCode: "MISSING_SIGNATURE" /* MISSING_SIGNATURE */
    };
  }
  parsed.signature.value = MultibaseCodec.decodeBase64url(parsed.signature.value);
  const signedObj = parsed;
  const verifyResult = await verifySignatureDetailed(signedObj, resolver, {
    maxClockSkew: opts.maxClockSkew
  });
  if (!verifyResult.ok) {
    return verifyResult;
  }
  const store = opts.nonceStore ?? defaultNonceStore;
  const maxSkew = opts.maxClockSkew ?? DEFAULT_MAX_CLOCK_SKEW;
  const ttlSeconds = maxSkew;
  const stored = await store.tryStoreNonce(
    signedObj.signature.signer_did,
    DEFAULT_DOMAIN_SEPARATOR,
    signedObj.signed_data.nonce,
    ttlSeconds
  );
  if (!stored) {
    return {
      ok: false,
      error: "Nonce replayed",
      errorCode: "NONCE_REPLAYED" /* NONCE_REPLAYED */,
      signedObject: signedObj
    };
  }
  return { ok: true, signedObject: signedObj };
}
var v1_default = {
  createSignature,
  toAuthorizationHeader,
  verifySignature,
  verifyAuthHeader,
  AuthErrorCode
};

// src/auth/index.ts
var DIDAuth = {
  v1: v1_exports
};
export {
  AUTH_PROVIDERS,
  AbstractVDR,
  IdentityKitErrorCode as AuthErrorCode,
  AuthErrorCodeMapping,
  Bytes,
  CadopIdentityKit,
  CadopServiceType,
  CryptoUtils,
  DIDAuth,
  DebugLogger,
  DefaultCryptoProviderFactory,
  DidAccountSigner,
  DidKeyCodec,
  EcdsaR1Provider,
  EcdsaR1PublicKey,
  Ed25519Provider,
  IdentityEnv,
  IdentityEnvBuilder,
  IdentityKit,
  IdentityKitError,
  IdentityKitErrorCode,
  InMemoryLRUDIDDocumentCache,
  KEY_TYPE,
  KeyManager,
  KeyMultibaseCodec,
  KeyStoreSigner,
  KeyType,
  KeyVDR,
  MemoryKeyStore,
  MultibaseCodec,
  IdentityKit as NuwaIdentityKit,
  RoochVDR,
  Secp256k1Provider,
  StoredKeyCodec,
  VDRRegistry,
  algorithmToKeyType,
  base64urlToBytes,
  bootstrapIdentityEnv,
  buildBaseScopes,
  buildDid,
  bytesToString,
  combineScopes,
  createAuthenticationError,
  createConfigurationError,
  createCryptoError,
  createDIDError,
  createDeepLinkError,
  createDefaultVDRs,
  createKeyManagementError,
  createMultibaseError,
  createReactError,
  createSignerError,
  createStorageError,
  createVDR,
  createVDRError,
  createValidationError,
  createWebError,
  defaultCryptoProviderFactory,
  extractFragment,
  extractFragmentFromId,
  extractIdentifier,
  extractMethod,
  getDidWithoutFragment,
  getSupportedAlgorithms,
  initRoochVDR,
  isDidAccountSigner,
  isIdentityKitError,
  isKeyType,
  isSignerInterface,
  isValidAddressFormat,
  keyTypeToAlgorithm,
  keyTypeToRoochSignatureScheme,
  parseDid,
  roochSignatureSchemeToKeyType,
  sameDid,
  scopeObjectToString,
  scopeObjectsToStrings,
  stringToBytes,
  toKeyType,
  validateScopeFormat,
  validateScopes,
  wrapUnknownError
};
//# sourceMappingURL=index.js.map